import React, { createContext, useContext, useState, useEffect } from 'react';

// Translations
const translations = {
  en: {
    // Header
    services: "Services",
    visaServices: "Visa Services",
    team: "Team",
    teamPageHeroTitle: "Meet the Experts Behind Registan Tourism",
    teamPageHeroDesc: "Our dedicated team of visa specialists is here to make your travel dreams a reality. With years of experience and a commitment to excellence, we ensure a seamless visa process for you.",
    teamPageLoading: "Loading team...",
    teamPageViewProfile: "View Profile",
    teamPageNavTours: "Tours",
    reviews: "Reviews",
    login: "Login",
    signUp: "Sign Up",
    logout: "Logout",
    dashboard: "Dashboard",
    
    // Hero
    heroTitle: "REGISTAN TOURISM",
    heroSubtitle: "Smart Visa Solutions for UAE",
    visasProcessed: "VISAS PROCESSED",
    fastProcessing: "FAST PROCESSING",
    successRate: "SUCCESS RATE",
    
    // Services
    ourVisaServices: "OUR VISA SERVICES",
    ourServices: "OUR SERVICES",
    catAll: "All",
    catVisa: "Visa",
    catBusiness: "Business",
    popularTours: "Popular tours most people visit",
    freelanceVisa: "Freelance Visa",
    visaChange: "Visa Change",
    bookNow: "Book Now",
    businessDays: "business days",
    hours: "hours",
    
    // Service Names
    dubaiVisa14Days: "Dubai Visa 14 Days",
    dubaiVisa30Days: "Dubai Visa",
    touristVisa: "Tourist Visa",
    dubaiVisa60Days: "Dubai Visa 60 Days",
    freelanceVisaName: "Freelance Visa",
    visaChange30Days: "30 Days Visa Change",
    visaChange60Days: "Visa Change",
    dubaiVisa: "Dubai Visa",
    
    // Service Descriptions
    desc14Days: "Tourist visa valid for 14 days from entry date",
    desc30Days: "Fast and reliable 30 day & 60 day UAE tourist visas with simple requirements and professional support. Apply with confidence and travel without stress.",
    desc60Days: "Long-term tourist visa valid for 60 days",
    descFreelance: "Professional freelance work permit and visa",
    descVisaChange30: "Express 30-day visa change service by car",
    descVisaChange60: "Change your UAE visa quickly and safely by car, bus, or air. Fast processing, legal compliance, and hassle-free service. Book easily and stay worry-free.",
    
    // Booking Modal
    bookYourVisaService: "Book Your Visa Service",
    selectTravelDate: "Select Travel Date",
    chooseTravelDate: "Choose your intended travel or visa processing date",
    yourInfoAndDocs: "Your Information & Documents",
    provideDetails: "Please provide your details and upload required documents",
    fullName: "Full Name",
    enterFullName: "Enter your full name",
    whatsappPhone: "WhatsApp / Phone Number",
    emailAddress: "Email Address",
    uploadDocuments: "Upload Documents",
    passportCopy: "Passport Copy",
    personalPhoto: "Personal Photo",
    clickToUpload: "Click to upload",
    confirmBooking: "Confirm Your Booking",
    reviewDetails: "Please review your booking details",
    service: "Service",
    travelDate: "Travel Date",
    yourInfo: "Your Information",
    uploadedDocs: "Uploaded Documents",
    confirmationNote: "We will contact you within 24 hours via WhatsApp to confirm your booking and provide payment details.",
    next: "Next",
    back: "Back",
    confirm: "Confirm Booking",
    submitting: "Submitting...",
    
    // Reviews
    customerReviews: "Customer Reviews",
    leaveReview: "Leave a Review",
    writeReview: "Write your review",
    submitReview: "Submit Review",
    
    // Footer
    yourTrustedPartner: "Your Trusted Visa Partner in UAE",
    goodToKnow: "Good to Know",
    bookingPolicy: "Booking Policy",
    bookingPolicyText: "Booking confirmation within 24 hours. Payment required before processing.",
    allRightsReserved: "All rights reserved",
    privacyPolicy: "Privacy Policy",
    joinTelegram: "Join Telegram",
    faq: "FAQ",
    viewSteps: "View Steps",
    visaStatus: "Visa Status",
    myTransactions: "My Transactions",
    chatAI: "Chat AI",
    chatAiGreeting: "Hello! How can I help you today?",
    chatApplyServices: "Apply for Services",
    chatApplyServicesDesc: "Browse and apply for visa services",
    chatCheckStatus: "Check Status",
    chatCheckStatusDesc: "Track your visa application",
    chatCallAdmin: "Message Admin",
    chatCallAdminDesc: "Send a message to admin",
    chatWriteToAdmin: "Please write your message and we will forward it to the admin. They will reply as soon as possible.",
    chatMessageSentAdmin: "Your message has been sent to the admin. Please wait, they will reply soon...",
    chatAdminReply: "Admin",
    chatWriteMessagePlaceholder: "Write your message to admin...",
    chatWriteMorePlaceholder: "Send another message...",
    // Visa result labels (VisaChecker)
    vrLabel_VF: "Visa Free",
    vrDesc_VF: "No visa needed. You can travel freely.",
    vrLabel_VOA: "Visa on Arrival",
    vrDesc_VOA: "You can get a visa when you arrive at the airport.",
    vrLabel_ETA: "ETA",
    vrDesc_ETA: "Electronic Travel Authorization required before departure.",
    vrLabel_EV: "eVisa",
    vrDesc_EV: "Apply for an electronic visa online before travel.",
    vrLabel_VR: "Visa Required",
    vrDesc_VR: "You must apply for a visa at an embassy or consulate.",
    vrLabel_NA: "No Admission",
    vrDesc_NA: "Entry is not permitted for this passport.",
    vrLabel_SAME: "Same Country",
    vrDesc_SAME: "Passport and destination are the same country.",
    chatSelectService: "Please select a service:",
    chatAiRedirecting: "Taking you there now...",
    chatTouristVisa: "Tourist Visa",
    chatTouristVisaDesc: "Apply for a Dubai tourist visa",
    chatVisaChange: "Visa Change",
    chatVisaChangeDesc: "Change your current visa status",
    chatFreelanceVisa: "Freelance Visa",
    chatFreelanceVisaDesc: "Get a freelance visa in Dubai",
    chatTours: "Tours",
    chatToursDesc: "Explore Dubai tours and activities",
    chatOpenCompany: "Open Company",
    chatOpenCompanyDesc: "Start your business in UAE",
    // Business Booking Modal
    bbmStep1Title: "Company Name",
    bbmStep2Title: "Your Name",
    bbmStep3Title: "Nationality",
    bbmStep4Title: "Mobile Number",
    bbmStep5Title: "Email Address",
    bbmStep6Title: "Personal Photo",
    bbmStep7Title: "Passport Copy",
    bbmStep8Title: "Review & Submit",
    bbmStepOf: "Step",
    bbmCompanyName: "Company Name",
    bbmCompanyPlaceholder: "e.g. Bright Horizons LLC",
    bbmCompanyHint: "Choose a unique name for your company",
    bbmNationalityHint: "As shown on your passport",
    bbmMobileHint: "Include country code (e.g. +971)",
    bbmEmailHint: "We'll send your application confirmation here",
    bbmPhotoNote: "Upload a clear, recent personal photo (passport-style). Optional — you can send it later.",
    bbmPassportNote: "Upload a clear scan/photo of your passport data page. Optional — you can send it later.",
    bbmWantVisa: "Include Investor Visa",
    uploadPhoto: "Click to upload photo",
    uploadPassport: "Click to upload passport",
    photoFormat: "JPG or PNG, max 5MB",
    passportFormat: "JPG, PNG or PDF, max 5MB",
    changePhoto: "Change",
    changeFile: "Change",
    businessSuccessText: "We received your request. Our team will reach out within 24 hours.",
    applicationSubmitted: "Application Submitted!",
    submitApplication: "Submit Application",
    fullName: "Full Name",
    investorVisa: "Investor Visa",
    total: "Total",
    yes: "Yes",
    no: "No",
    zone: "Type",
    chatAskReference: "Please enter your booking reference number:",
    chatAskReferenceForAdmin: "Please enter your booking reference number so admin can help you better:",
    chatAdminMessageReady: "Thanks {name}! Now write your message and we will forward it to the admin.",
    chatAskPassport: "Booking found! Please enter your passport number to verify:",
    chatBookingNotFound: "Booking not found. Please check your reference number and try again.",
    chatPassportMismatch: "Passport number does not match. Please try again.",
    chatWelcome: "Welcome",
    chatCurrentStatus: "Current Status",
    chatAgent: "Agent",
    chatWhoIsMyAgent: "Who is my agent?",
    chatYourAgent: "Your agent is",
    chatAskAgentNumber: "Ask Agent Number",
    chatAgentNumber: "Agent number",
    chatAskQuestion: "Ask about your visa...",
    chatSendToAdmin: "Send to Admin",
    chatSentToAdmin: "Your message has been sent to the admin. They will contact you soon.",
    chatSentLabel: "Sent to admin",
    chatOfferAdmin: "Would you like me to send your message to the admin? Please write clearly what you need and I will forward it.",
    chatBackToMenu: "Back to Menu",
    chatRefPlaceholder: "e.g. RAMIZ20260001",
    chatPassportPlaceholder: "e.g. FA3204764",
    chatError: "Something went wrong. Please try again.",
    chatOnline: "Online",
    chatApprovedDocs: "Approved Documents",
    chatVoiceListen: "Listen to Status",
    chatVoiceStop: "Stop",
    startBusiness: "Start Business",
    home: "Home",
    tours: "Tours",
    about: "About",

    // Tours Page
    tourHeroBadge: "Dubai Tours & Activities",
    tourHeroTitle: "Explore the Best of Dubai",
    tourHeroDesc: "Desert safaris, Burj Khalifa tickets, jet ski adventures, city tours, dinner cruises and more — all at the best prices with Registan Tourism.",
    tourBookViaWhatsApp: "Book via WhatsApp",
    tourAll: "All",
    tourLoading: "Loading tours...",
    tourNoTours: "No tours available",
    tourCheckBack: "Check back soon for exciting Dubai tours!",
    tourBookNow: "Book Now",
    tourWhyTitle: "Why Book Dubai Tours with Registan Tourism?",
    tourBestPrice: "Best Price Guarantee",
    tourBestPriceDesc: "We offer the most competitive prices for all Dubai tours and activities. No hidden fees.",
    tourExpertGuides: "Expert Local Guides",
    tourExpertGuidesDesc: "All tours led by certified local guides who know Dubai inside out.",
    tourFlexibleBooking: "Flexible Booking",
    tourFlexibleBookingDesc: "Free cancellation up to 24 hours before. Book now, pay later option available.",
    tourWhatsAppSupport: "24/7 WhatsApp Support",
    tourWhatsAppSupportDesc: "Instant booking and support on WhatsApp. We respond within minutes.",
    tourReadyTitle: "Ready for Your Dubai Adventure?",
    tourReadyDesc: "Contact us on WhatsApp for instant booking, custom tour packages, and group discounts.",
    tourBookTour: "Book Tour",
    tourGuestName: "Guest Name",
    tourBookingDate: "Booking Date",
    tourNumberOfPeople: "Number of People",
    tourMobileNumber: "Mobile Number",
    tourEmailAddress: "Email Address",
    tourCurrentLocation: "Current Location",
    tourFullName: "Full name",
    tourHotelOrArea: "Hotel name or area",
    tourPricePerPerson: "Price per person",
    tourPeople: "People",
    tourTotal: "Total",
    tourCancel: "Cancel",
    tourSubmitBooking: "Submit Booking",
    tourSubmitting: "Submitting...",
    tourBookingSubmitted: "Booking Submitted!",
    tourBookingThankYou: "Your booking has been received. Our team will contact you shortly.",
    tourDone: "Done",

    // FAQ Page
    backToHome: "Back to Home",
    faqTitle: "Frequently Asked Questions",
    faqSubtitle: "Find answers to common questions about our visa services, processing times, and more.",
    stillHaveQuestions: "Still have questions?",
    contactUsAnytime: "Our team is available 24/7 to assist you with any queries.",
    
    // Booking Card
    open: "Open",
    closesAt: "Closes at",
    contactUs: "Contact Us",
    whatsapp: "WhatsApp",
    callNow: "Call Now",
    
    // Auth
    welcomeBack: "Welcome Back",
    signInAccess: "Sign in to access your bookings and dashboard",
    createAccount: "Create Account",
    joinUs: "Join us to book visa services and track your applications",
    password: "Password",
    enterPassword: "Enter your password",
    forgotPassword: "Forgot Password?",
    signIn: "Sign In",
    dontHaveAccount: "Don't have an account?",
    alreadyHaveAccount: "Already have an account?",
    
    // Dashboard
    myBookings: "My Bookings",
    myReviews: "My Reviews",
    profile: "Profile",
    noBookings: "No bookings yet",
    home: "Home",
    transactions: "Transactions",
    approved: "Approved",
    
    // Common
    loading: "Loading...",
    error: "Error",
    success: "Success",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    view: "View",
    download: "Download",
    remove: "Remove",
    // Booking form
    firstName: "First Name",
    lastName: "Last Name",
    dateOfPlanning: "Date of Planning",
    nationality: "Nationality",
    selectNationality: "Select nationality",
    selectVisaDuration: "Select Visa Duration",
    chooseVisaDuration: "Choose your preferred visa duration",
    chooseTransport: "How do you want to do your visa change?",
    selectTransportMethod: "Please choose one",
    readingPassport: "Reading passport data...",
    passportDataExtracted: "Passport data extracted — you can edit if incorrect",
    dateOfBirth: "Date of Birth",
    passportNumber: "Passport Number",
    // Visa Checker
    visaChecker: "Visa Checker",
    visaCheckerDesc: "Check visa requirements for any destination worldwide",
    yourCitizenship: "Your Citizenship",
    destination: "Destination",
    selectCountry: "Select country...",
    checkVisa: "Check Visa Requirements",
    checking: "Checking...",
    sameCountryError: "Citizenship and destination cannot be the same",
    visaCheckError: "Could not check visa requirements. Please try again.",
    stayDuration: "Stay duration",
    applyNow: "Apply Now",
    applyForVisa: "Apply for Visa",
    applicationSent: "Application Sent!",
    applicationSentDesc: "We will contact you shortly about your visa application.",
    submitApplication: "Submit Application",
    areYouUAEResident: "Are you a resident of UAE?",
    enterEmail: "Enter your email address",
    submitting: "Submitting...",
    done: "Done",
    yes: "Yes",
    no: "No",
    // SEO Content
    seoDubaiTitle: "Dubai Visa Services — Apply Online for UAE Tourist Visa",
    seoDubaiP1: "Registan Tourism is a trusted visa service provider helping thousands of travelers apply for a Dubai visa quickly and affordably. Whether you need a short-stay 14-day tourist visa, a standard 30-day UAE visa, or an extended 60-day Dubai visa, we handle the entire process from document verification to application submission. Our team ensures fast processing times of 3 to 5 business days, so you can plan your trip to the United Arab Emirates with confidence.",
    seoDubaiP2: "Applying for a Dubai tourist visa online has never been easier. Simply upload your passport, and our smart OCR system automatically reads your passport details including nationality, date of birth, passport number, issue date, and expiry date. We verify that your passport is valid for at least six months before processing your application, ensuring full compliance with UAE immigration requirements. Our service covers all nationalities, and we provide real-time visa status tracking so you always know where your application stands.",
    seoDubaiP3: "Dubai is one of the most visited cities in the world, attracting millions of tourists every year for business, leisure, and transit. With Registan Tourism, you get competitive pricing starting from AED 350 for a 14-day visa, AED 500 for a 30-day visa, and AED 800 for a 60-day visa. Our dedicated customer support team is available via WhatsApp and live chat to answer all your questions about UAE visa requirements, entry regulations, and travel documentation. Book your Dubai visa today and experience hassle-free travel to the UAE.",
    seoVisaChangeTitle: "Visa Change Service in UAE — By Car, Bus, or Airplane",
    seoVisaChangeP1: "Need to renew or change your visa status in the UAE? Registan Tourism offers a complete visa change service, also known as a visa run, that allows you to exit and re-enter the country to obtain a new visa. We provide three convenient travel options: visa change by car to Oman, visa change by bus, or visa change by airplane. Each method is fully managed by our experienced team, so you can complete your visa change process smoothly and without any complications.",
    seoVisaChangeP2: "Our visa change by car service is the most popular option, taking you on a comfortable drive to the Oman border and back within just a few hours. For those who prefer a budget-friendly alternative, our bus service offers an affordable visa run with professional coordination at every step. If you need a faster turnaround or prefer air travel, our airplane visa change service provides the quickest option with flights arranged to nearby destinations. All options include 30-day and 60-day visa renewals, with prices starting from AED 750 for a 30-day visa change by bus and going up based on your chosen travel method.",
    seoVisaChangeP3: "The visa change process in the UAE is essential for residents and visitors who need to switch between visa types, extend their stay, or reset their visa validity. Registan Tourism simplifies this process with transparent pricing, real-time updates, and door-to-door coordination. Our smart booking system calculates your total cost instantly based on your visa duration and travel method. Whether you are a tourist, a freelancer, or a business professional in Dubai, Abu Dhabi, or any other emirate, we provide reliable visa change services that save you time and effort. Contact us today to schedule your visa change.",
    enterNamePassport: "Enter your name as it appears on your passport",
    selectTravelDate: "Select your planned travel date",
    days: "Days",
    // Dubai Visa Steps
    dubaiStep1Title: "How Can I Apply?",
    dubaiStep1Desc: "This visa must be applied for while you are outside the UAE in order to be approved.",
    dubaiStep2Title: "What Is the Validity of the Visa?",
    dubaiStep2Desc: "Once your visa is approved—whether it is a 30-day or 60-day visa—you can enter the UAE anytime before your visa expiry date. After entering the UAE, the visa duration starts counting from your entry date: a 30-day visa allows 29 days of stay, and a 60-day visa allows 58 days.",
    dubaiStep3Title: "Can I renew my visa?",
    dubaiStep3Desc: "Yes, you can renew your visa inside the UAE without leaving the country. The 30-day visa can be renewed up to 2 times only.",
    // Visa Change Steps
    vcStep1Title: "Choose Travel Method",
    vcStep1Desc: "Select how you want to do your visa change: by car to Oman border, by bus, or by airplane. Each method has different processing times and costs.",
    vcStep2Title: "Upload Documents",
    vcStep2Desc: "Upload your passport copy and a personal photo. Our team will prepare all required documents for your visa change.",
    vcStep3Title: "Travel & Border Processing",
    vcStep3Desc: "Travel to the border or airport as planned. Our agent will assist you through the entire exit and re-entry process.",
    vcStep4Title: "New Visa Issued",
    vcStep4Desc: "After re-entry, your new visa is stamped and activated. You will receive confirmation with your new visa details.",
    // Family Visa Steps
    familyVisaName: "Family Visa",
    familyVStep1Title: "Select Family Member",
    familyVStep1Desc: "Choose who you want to apply the Family Visa for: Husband, Wife, Son, Daughter, or Mother.",
    familyVStep2Title: "Upload Documents",
    familyVStep2Desc: "Upload the passport copy and a personal photo of the family member you are applying for.",
    familyVStep3Title: "Emirates ID Preview",
    familyVStep3Desc: "Our system generates an Emirates ID preview from the passport data. Verify that all details are correct before proceeding.",
    familyVStep4Title: "Contact Information",
    familyVStep4Desc: "Provide your WhatsApp number and email address so our team can reach you with updates on your application.",
    familyVStep5Title: "Review & Confirm",
    familyVStep5Desc: "Review all the details of your Family Visa application and confirm the submission. You will receive a tracking number to check the status.",
    
    // Freelance Visa Steps
    freelanceVStep1Title: "Submit Application",
    freelanceVStep1Desc: "Fill in your personal details, upload your passport copy and photo. Our team will begin processing your freelance visa.",
    freelanceVStep2Title: "Visa Approved",
    freelanceVStep2Desc: "Your freelance visa application is reviewed and approved. You will receive confirmation with your visa approval document.",
    freelanceVStep3Title: "Option Change",
    freelanceVStep3Desc: "Your visa status is updated in the system. Required option changes are processed for your freelance permit.",
    freelanceVStep4Title: "Medical Test",
    freelanceVStep4Desc: "Complete the mandatory medical fitness test at an approved health center. Results are submitted to immigration.",
    freelanceVStep5Title: "Residence Visa",
    freelanceVStep5Desc: "Your UAE residence visa is issued. This allows you to live and work legally in the UAE as a freelancer.",
    freelanceVStep6Title: "Emirates ID",
    freelanceVStep6Desc: "Your Emirates ID is processed and issued. This is your official UAE identity document for all transactions.",

    // Modal Common
    howItWorks: "How It Works",
    gotIt: "Got It",

    // Dashboard Page
    loadingDashboard: "Loading your dashboard...",
    noBookingsYet: "No Bookings Yet",
    noBookingsDesc: "You haven't made any bookings. Start exploring our visa services!",
    browseServices: "Browse Services",
    total: "total",
    nameLabel: "Name",
    nationalityLabel: "Nationality",
    passportNumberLabel: "Passport No",
    travelDateLabel: "Travel Date",
    priceLabel: "Price",
    bookedLabel: "Booked",
    yourDocuments: "Your Documents",
    passport: "Passport",
    photo: "Photo",
    documentFromRegistan: "Document from Registan Tourism",
    downloadDocument: "Download Document",
    weWillContact: "We will contact you at",
    contactViaWhatsApp: "Contact via WhatsApp",
    deleteBookingTitle: "Delete Booking?",
    deleteWarning: "Warning: This action cannot be undone!",
    deleteInfo: "You are about to permanently delete booking:",
    deletePermanent: "This booking and all associated documents will be permanently deleted from the system forever.",
    yesDeleteForever: "Yes, Delete Forever",
    deleting: "Deleting...",
    noReviewsYet: "No Reviews Yet",
    noReviewsDesc: "You haven't left any reviews. Share your experience!",
    rating: "Rating",
    review: "Review",
    saveChanges: "Save Changes",
    editPhoto: "Edit Photo",
    updateProfilePhoto: "Update Profile Photo",
    uploadPhotoOrAvatar: "Upload a photo or choose an avatar",
    uploadPhoto: "Upload Photo",
    chooseAvatar: "Choose Avatar",
    removePhoto: "Remove Photo",
    uploading: "Uploading...",
    documentRequired: "Document Required",
    documentReuploadRequired: "Document Re-upload Required",
    required: "Required",
    reason: "Reason",
    reupload: "Re-upload",
    submitDocument: "Submit Document",
    uploadingDocument: "Uploading document...",
    selected: "Selected",
    signingIn: "Signing In...",
    creatingAccount: "Creating Account...",
    mobileNumber: "Mobile Number",
    optional: "Optional",
    minChars: "Minimum 6 characters",
    joinRegistan: "Join Registan Tourism and manage your bookings",
    date: "Date",
    details: "Details",
    
    // Forgot Password
    forgotPassword: "Forgot Password?",
    forgotPasswordTitle: "Forgot Password?",
    forgotPasswordDesc: "Enter your email address and we'll send you a link to reset your password.",
    sendResetLink: "Send Reset Link",
    sending: "Sending...",
    checkYourEmail: "Check Your Email",
    resetEmailSent: "We've sent a password reset link to your email. Please check your inbox.",
    backToLogin: "Back to Login",
    rememberPassword: "Remember your password?",
    forgotPasswordError: "Failed to send reset email. Please try again.",
    
    // Reset Password Page
    resetPasswordTitle: "Reset Password",
    resetPasswordDesc: "Enter your new password below.",
    verifyingToken: "Verifying your reset link...",
    invalidToken: "Invalid or Expired Link",
    invalidTokenDesc: "This password reset link is invalid or has expired. Please request a new one.",
    requestNewLink: "Request New Link",
    passwordResetSuccess: "Password Reset Successfully!",
    passwordResetSuccessDesc: "Your password has been updated. Redirecting to login...",
    goToLogin: "Go to Login",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    enterNewPassword: "Enter new password",
    confirmNewPassword: "Confirm new password",
    resetPassword: "Reset Password",
    resetting: "Resetting...",
    passwordMinLength: "Password must be at least 6 characters",
    passwordsNoMatch: "Passwords do not match",
    resetPasswordError: "Failed to reset password. Please try again.",
    
    jpgPngPdf: "JPG, PNG or PDF (max 5MB)",
    jpgPng: "JPG or PNG (max 5MB)",
    clickToUploadPassport: "Click to upload passport",
    clickToUploadPhoto: "Click to upload photo",
    usingAccountEmail: "Using your account email",
    star: "star",
    stars: "stars",
    
    // Step-by-Step Booking
    enterFullNamePassport: "Enter your full name as it appears on your passport",
    enterPhoneContact: "Enter your WhatsApp number so we can contact you",
    enterEmailConfirmation: "Enter your email for booking confirmation",
    uploadPassport: "Upload Passport",
    uploadPassportInstruction: "Upload a clear photo of your passport. We will automatically extract your information.",
    uploadPhotoInstruction: "Upload a clear personal photo for your visa application",
    extractingData: "Extracting passport data...",
    extractedInfo: "Extracted Information",
    surname: "Surname",
    givenNames: "Given Names",
    dateOfBirth: "Date of Birth",
    nationality: "Nationality",
    passportNumber: "Passport Number",
    passportExpiry: "Expiry Date",
    reviewConfirm: "Review & Confirm",
    reviewInstruction: "Please review your details before confirming.",
    contactInfo: "Contact Information",
    passportInfo: "Passport Information",
    phone: "Phone",
    email: "Email",
    expiryDate: "Expiry Date",
    issueDate: "Issue Date",
    notPassportError: "This does not appear to be a passport. Please upload your passport.",
    passportExpiringSoon: "Your passport expires in less than 6 months. Please renew your passport before applying.",
    bookingSuccess: "Booking successful!",
    bookingFailed: "Booking failed. Please try again.",
    pleaseEnterName: "Please enter your full name",
    pleaseEnterPhone: "Please enter your phone number",
    pleaseEnterEmail: "Please enter your email",
    pleaseUploadPassport: "Please upload your passport",
    pleaseUploadPhoto: "Please upload your photo",
    uploadPassportSimple: "Upload a clear photo of your passport",
    // Debit Card
    debitCardQuestion: "Do you need a Debit Card?",
    debitCardDescription: "Get a UAE bank debit card along with your freelance visa for an additional 500 AED",
    debitCard: "Debit Card",
    yes: "Yes",
    no: "No",
    skipDebitCard: "Skip",
    pleaseSelectDebitCard: "Please select Yes or No",
    // PDF Number Remover
    pdfTitle: "Remove +971 Numbers from Files",
    pdfDescription: "Upload a PDF, JPG, or PNG file. The system will automatically detect and remove all UAE mobile numbers (+971XXXXXXXXX) and return the cleaned file.",
    pdfDropzone: "Drop your file here or click to browse",
    pdfDropzoneHint: "Supports PDF, JPG, PNG (max 20MB)",
    pdfYourNumber: "Your number (optional)",
    pdfYourNumberHint: "Enter your number to replace the removed ones",
    pdfRemoveBtn: "Remove Numbers",
    pdfProcessing: "Processing...",
    pdfComplete: "Processing Complete",
    pdfFoundAndReplaced: "Found",
    pdfNumbers: "number(s)",
    pdfFoundAndRemoved: "Found and removed",
    pdfNoNumbers: "No +971 phone numbers were found in your file.",
    pdfNumbersRemoved: "Numbers Removed",
    pdfDownload: "Download Cleaned File",
    pdfAnother: "Process Another File",
    pdfSecure: "Your files are processed securely and deleted after download",
    pdfSupports: "Supports PDF documents, JPG and PNG images",
    pdfOnlyFileTypes: "Please upload a PDF, JPG, or PNG file only.",
    pdfFileTooLarge: "File size must be less than 20MB.",
    pdfProcessingFailed: "Failed to process file. Please try again.",
    // 404 Page
    notFoundTitle: "Looks like you're off the map",
    notFoundText: "The page you're looking for drifted into the desert. Let's get you back on route.",
    notFoundBtn: "Take me home",
    notFoundTryLabel: "Or try:",
    goneTitle: "This Page Has Been Removed",
    goneText: "This page no longer exists and has been permanently removed.",
    // About Page
    aboutMetaTitle: "About Registan Tourism — Trusted Dubai Visa Services & UAE Travel Agency",
    aboutMetaDesc: "Registan Tourism is a leading Dubai visa service provider offering UAE tourist visas, visa change services, family visa sponsorship, freelance visas, and business setup in Dubai.",
    aboutBadge: "Based in Dubai, UAE",
    aboutHeroTitle: "Registan Tourism — Your Trusted Dubai Visa Service Provider & UAE Travel Agency",
    aboutHeroDesc: "We help thousands of travelers apply for a Dubai visa online, process UAE visa changes, and set up businesses in the Emirates. Fast, reliable, and affordable visa services with 24/7 customer support.",
    aboutApplyBtn: "Apply for Dubai Visa",
    aboutWhatsappBtn: "WhatsApp Us",
    aboutStatCountries: "Countries Served",
    aboutStatSupport: "Customer Support",
    aboutStatApproval: "Approval Rate",
    aboutWhoTitle: "Your Gateway to the UAE — Built on Trust, Powered by Experience",
    aboutWhoP1: "Registan Tourism is a professionally managed Dubai visa agency and UAE travel services provider helping travelers from over 15 countries obtain their UAE tourist visas, visit visas, and transit visas quickly and efficiently. Our team of experienced immigration consultants ensures every application is processed with the highest accuracy and compliance with UAE immigration laws.",
    aboutWhoP2: "Whether you need a 14-day Dubai visa, 30-day UAE tourist visa, or 60-day long-stay visa, we handle the entire process from document verification to visa stamping. Our smart online booking system uses passport OCR technology to automatically read your passport details, reducing errors and speeding up the application process.",
    aboutWhoP3: "Beyond tourist visas, we specialize in visa change services in the UAE — also known as visa runs. Our visa change by car to Oman, visa change by bus, and visa change by airplane options provide flexible and convenient ways to renew your visa status without leaving the country for long.",
    aboutWhoP4: "We also offer family visa sponsorship in Dubai, freelance visa and business license setup in UAE free zones, and expert UAE immigration consultation. Our goal is to make visa services accessible, transparent, and stress-free for everyone visiting or living in the United Arab Emirates.",
    aboutServicesTitle: "Our Dubai Visa & UAE Travel Services",
    aboutServicesSubtitle: "Comprehensive visa and immigration solutions for tourists, residents, and businesses in the UAE",
    aboutSvcVisaTitle: "Dubai Tourist Visa",
    aboutSvcVisaDesc: "14, 30, and 60-day UAE tourist visas with fast processing in 3-5 business days.",
    aboutSvcChangeTitle: "Visa Change Service",
    aboutSvcChangeDesc: "Hassle-free visa change by car, bus, or airplane with border run coordination.",
    aboutSvcFamilyTitle: "Family Visa UAE",
    aboutSvcFamilyDesc: "Sponsor your husband, wife, son, daughter, or mother for UAE family residence visa.",
    aboutSvcBusinessTitle: "Business Setup Dubai",
    aboutSvcBusinessDesc: "Complete freelance visa and business license setup in Dubai free zones.",
    aboutSvcConsultTitle: "Visa Consultation",
    aboutSvcConsultDesc: "Expert guidance on UAE immigration, visa types, requirements, and documentation.",
    aboutSvcPremiumTitle: "Premium Service",
    aboutSvcPremiumDesc: "Priority processing, VIP support, and dedicated case manager for urgent applications.",
    aboutWhyTitle: "Why Choose Registan Tourism for Your Dubai Visa?",
    aboutWhySubtitle: "Trusted by hundreds of travelers worldwide for reliable UAE visa services",
    aboutWhyFastTitle: "Fast Processing",
    aboutWhyFastDesc: "Get your Dubai visa approved in 3-5 business days with our streamlined application system.",
    aboutWhyTrustedTitle: "Trusted & Licensed",
    aboutWhyTrustedDesc: "Authorized visa service provider registered in the UAE with years of immigration expertise.",
    aboutWhyApprovalTitle: "High Approval Rate",
    aboutWhyApprovalDesc: "99% visa approval rate thanks to our thorough document verification and compliance checks.",
    aboutWhyReviewsTitle: "5-Star Reviews",
    aboutWhyReviewsDesc: "Hundreds of satisfied customers from around the world trust Registan Tourism for their UAE visa.",
    aboutWhyWhatsappTitle: "24/7 WhatsApp Support",
    aboutWhyWhatsappDesc: "Get instant help anytime via WhatsApp, live chat, or email from our multilingual support team.",
    aboutWhyLocalTitle: "Based in Dubai",
    aboutWhyLocalDesc: "Local presence in Dubai with deep knowledge of UAE visa regulations and immigration policies.",
    aboutCtaTitle: "Ready to Apply for Your Dubai Visa?",
    aboutCtaDesc: "Start your UAE visa application today. Fast processing, affordable prices, and dedicated support from our Dubai-based team.",
    aboutCtaBtn: "Apply Now",
    // Chat
    startChat: "Start Chat",
    registanSupport: "Registan Support",
    chatWelcome: "Welcome!",
    chatWelcomeDesc: "Enter your details to start chatting or continue a previous conversation.",
    yourName: "Your Name",
    enterYourName: "Enter your name",
    phoneNumber: "Phone Number",
    startChatBtn: "Start Chat",
    loadingChat: "Loading...",
    loadingMessages: "Loading messages...",
    noMessagesYet: "No messages yet. Start the conversation!",
    typeMessage: "Type a message...",
    sending: "Sending...",
    // Admin
    addService: "Add Service",
    editService: "Edit Service",
    deleteBtn: "Delete",
    editBtn: "Edit",
    stepsBtn: "Steps",
    nSteps: "Steps",
    serviceName: "Service Name",
    price: "Price",
    duration: "Duration",
    subtitle: "Subtitle",
    category: "Category",
    description: "Description",
    serviceImage: "Service Image",
    saveChanges: "Save Changes",
    cancel: "Cancel",
    selectCategory: "Select category",
    moveUp: "Move up",
    moveDown: "Move down",
    
    // Family Visa
    familyVisa: "Family Visa",
    familyVisaName: "Family Visa",
    descFamilyVisa: "Bring your family to the UAE with our professional family visa service. We handle all documentation, sponsor requirements, and ensure a smooth process for your loved ones.",
    whoApplyVisaFor: "Who do you want to apply visa for?",
    selectFamilyMember: "Select a family member",
    husband: "Husband",
    son: "Son",
    daughter: "Daughter",
    mother: "Mother",
    uploadPassportPhoto: "Upload Passport & Photo",
    uploadPassportPhotoOf: "Please upload passport and personal photo of",
    emiratesIdPreview: "Emirates ID Preview",
    reviewPassportInfo: "Review the information extracted from passport",
    firstNameLabel: "First Name",
    lastNameLabel: "Last Name",
    dateOfBirthLabel: "Date of Birth",
    nationalityLabel: "Nationality",
    unitedArabEmirates: "UNITED ARAB EMIRATES",
    confirmApplication: "Confirm Application",
    reviewSubmitFamilyVisa: "Please review and submit your Family Visa application",
    applyingFor: "Applying For",
    name: "Name",
    bySubmittingAgree: "By submitting, you agree to our terms and conditions. We will contact you within 24 hours.",
    dataExtracted: "Data Extracted",
    goBackUploadClear: "Please go back and upload a clear passport photo to extract information",
    clickUploadPassport: "Click to upload passport",
    clickUploadPhoto: "Click to upload photo",
    readingPassportData: "Reading passport data...",
    contactInfo: "Contact Information",
    enterContactDetails: "Please enter your contact details so we can reach you",
    whatsappNumber: "WhatsApp Number",
    emailAddress: "Email Address",
    weWillContactYou: "We will contact you via WhatsApp for updates on your application",
    telegram: "Telegram",
    telegramOptional: "Telegram (Optional)",
    telegramOptionalHint: "We can deliver your visa documents directly to Telegram once approved.",
    phoneOrTelegram: "Phone or Telegram Number",
    phoneOrTelegramHint: "Write your phone number or Telegram number so we can share the documents to your Telegram once approved.",
    phoneOrTelegramNote: "WhatsApp number or Telegram @username — both work.",
    contactNumbers: "Contact Numbers",
    phoneNumber: "Phone Number",
    phoneAndTelegramHint: "Enter your phone number and your Telegram/WhatsApp so we can share approved documents.",
    sameNumberForTelegram: "I use the same number for Telegram / WhatsApp",
    telegramOrWhatsapp: "Telegram or WhatsApp Number",
    telegramShareDocsHint: "We will share your approved documents to this Telegram/WhatsApp.",
    pleaseEnterTelegram: "Please enter your Telegram or WhatsApp number, or check 'same number'.",
    
    // Transport methods (for visa change)
    by: "by",
    car: "car",
    bus: "bus",
    airplane: "airplane",

    // Tourism Software Hub
    tourismSoftware: "Tourism Software",
    tourismSoftwareTitle: "Tourism Software",
    tourismSoftwareSubtitle: "Free online tools built for travelers, agencies and visa applicants",
    bgRemoverTool: "Background Remover",
    bgRemoverDesc: "Remove image backgrounds instantly using AI. Download as PNG or JPG with custom colors.",
    dummyFlightTool: "Dummy Flight Ticket",
    dummyFlightDesc: "Generate realistic sample flight tickets for visa applications. Any route worldwide.",
    imageResizerTool: "Image Resizer",
    imageResizerDesc: "Resize, compress and convert images. Reduce file size, change dimensions and format instantly.",
    stampMakerTool: "Stamp Maker Tool",
    stampMakerDesc: "Design and create custom digital rubber stamps for your business documents and official papers.",
    resumeBuilderTool: "Resume Builder",
    resumeBuilderDesc: "Build a professional resume or CV online for free. Choose modern templates and download as PDF.",
    stampPageH1: "Free Online Stamp Maker — Create Custom Digital Rubber Stamps",
    stampPageH2: "Design Professional Company Stamps for Documents, Invoices & Official Papers",
    stampPageText: "Create high-quality digital rubber stamps instantly with our free online stamp maker tool. Whether you need a round company seal, a rectangular approval stamp, or a custom signature stamp for your business documents, our tool lets you design and download professional stamps in seconds. Perfect for freelancers, small businesses, and enterprises in the UAE and worldwide. Choose from multiple shapes, add your company name, registration number, and logo — then download your stamp as a transparent PNG ready to use on invoices, contracts, and official paperwork. No registration required, completely free.",
    stampToolTitle: "Stamp Maker Tool",
    stampComingSoon: "Coming Soon — We're building a powerful stamp creation tool for you.",
    resumePageH1: "Professional Resume Builder — Land Your Dream Job in the UAE & Worldwide",
    resumePageH2: "Craft a Stunning CV That Gets You Hired — Free, Fast & Ready to Download as PDF",
    resumePageText: "Your resume is the first impression you make on any employer — make it count. Our professional resume builder is designed for job seekers in Dubai, Abu Dhabi, and across the UAE, as well as internationally. Whether you are a seasoned executive, a mid-career professional switching industries, or a fresh graduate entering the workforce, our tool helps you present your experience, skills, and qualifications in a clean, modern format that stands out. Simply enter your personal details, work history, education, languages, and skills — our system instantly generates a polished, ATS-friendly CV that you can download as a high-quality PDF. No registration, no watermarks, no hidden fees. Used by thousands of professionals across the Middle East, South Asia, and CIS countries. Start building your career advantage today.",
    resumeToolTitle: "Resume Builder Tool",
    resumeComingSoon: "Coming Soon — We're building a powerful resume creation tool for you.",
    // Freelance Visa Page
    fvPageH1: "Dubai Freelance Visa 2026 — Work Independently in the UAE with Full Legal Residency",
    fvPageH2: "Apply Online for Your UAE Freelancer Permit — Fast Processing, Complete Support from Registan Tourism",
    fvPageDesc: "Start your freelance career in Dubai with a fully legal UAE freelance visa from Registan Tourism. Our end-to-end service covers trade license issuance, visa stamping, Emirates ID processing, and medical examination — all completed within 5 to 7 business days. Whether you are a designer, developer, consultant, content creator, or any independent professional, our team handles every step so you can focus on growing your business. We offer transparent pricing starting from AED 5,000 with no hidden charges, door-to-door document pickup, and real-time status tracking through your personal dashboard. Join thousands of freelancers who trust Registan Tourism for reliable, fast, and affordable visa services in the UAE.",
    fvApplyBtn: "Apply for Freelance Visa Now",
    fvPrice: "From AED 5,000",
    fvDuration: "Processing: 5-7 Days",
    fvFeaturesTitle: "What's Included",
    fvFeature1: "Freelance Trade License",
    fvFeature2: "UAE Residence Visa Stamping",
    fvFeature3: "Emirates ID Processing",
    fvFeature4: "Medical Fitness Test",
    fvFeature5: "Document Pickup & Delivery",
    fvFeature6: "Real-Time Status Tracking",
    fvFeature7: "Dedicated Support Manager",
    fvFeature8: "No Hidden Fees",
    // Resume Builder
    rbFormTitle: "Build Your Resume",
    rbPersonal: "Personal Information",
    rbPhoto: "Photo",
    rbUploadPhoto: "Upload Photo",
    rbFullName: "Full Name",
    rbFullNamePh: "John Doe",
    rbJobTitle: "Job Title",
    rbJobTitlePh: "Software Developer",
    rbMobile: "Mobile",
    rbEmail: "Email",
    rbAddress: "Address",
    rbAddressPh: "Dubai, UAE",
    rbAboutMe: "About Me",
    rbAboutMePh: "Write a short summary about yourself...",
    rbWorkExp: "Work Experience",
    rbPosition: "Position",
    rbCompany: "Company",
    rbCountry: "Country",
    rbFromYear: "From (year)",
    rbToYear: "To (year)",
    rbPresent: "Present",
    rbAddWork: "Add Experience",
    rbEducation: "Education",
    rbInstitution: "Institution",
    rbCity: "City",
    rbAddEdu: "Add Education",
    rbSkills: "Skills",
    rbSkillPh: "e.g. React, Photoshop",
    rbLanguages: "Languages",
    rbLangPh: "e.g. English",
    rbHobbies: "Hobbies",
    rbHobbyPh: "e.g. Photography",
    rbSocialLinks: "Social Links",
    rbLinkText: "Display text (e.g. My Portfolio)",
    rbDownloadPDF: "Download PDF",
    rbDownloading: "Generating PDF...",
    rbDesignStyle: "Design Style",
    rbClassic: "Classic",
    rbModern: "Modern",
    rbCreative: "Creative",
    rbYourName: "Your Name",
    rbCreateResume: "Create My Resume",
    rbFreeForever: "FREE FOREVER",
    rbBadge1: "No Registration Required",
    rbBadge2: "ATS-Friendly Format",
    rbBadge3: "Used Worldwide",

    // Background Remover Page
    bgRemoverTitle: "Background Remover",
    bgRemoverSubtitle: "Remove image backgrounds instantly with AI. Upload any photo and download with transparent or custom colored background.",
    uploadImage: "Upload Image",
    dropImageHere: "Drop your image here or tap to upload",
    supportedFormats: "PNG, JPG, WEBP up to 10MB",
    processing: "Processing...",
    removingBackground: "Removing background...",
    downloadPNG: "Download PNG",
    downloadJPG: "Download JPG",
    bgColor: "Background Color",
    transparent: "Transparent",
    removeAnother: "Remove Another",

    // KeyFlight Page
    flightTicketGenerator: "Flight Ticket Generator",
    flightTicketSubtitle: "Generate professional e-ticket itineraries for visa applications. Select any route worldwide.",
    passengerName: "Passenger Name",
    tripType: "Trip Type",
    oneWay: "One Way",
    roundTrip: "Round Trip",
    from: "From",
    to: "To",
    departureDate: "Departure Date",
    returnDate: "Return Date",
    searchFlights: "Search Flights",
    selectYourFlight: "Select Your Flight",
    outboundFlights: "Outbound Flights",
    returnFlights: "Return Flights",
    generateTicket: "Generate Ticket",
    back: "Back",
    yourTicketReady: "Your E-Ticket is Ready!",
    downloadETicket: "Download E-Ticket",
    sendToEmail: "Send to Email",
    generateNew: "Generate New",
    sendTicketTitle: "Send E-Ticket to Email",
    sendTicketDesc: "Enter the email address to receive the e-ticket itinerary.",
    sendETicket: "Send E-Ticket",
    sending: "Sending...",
    ticketSentSuccess: "E-Ticket sent successfully!",

    // Image Resizer Page
    imageResizerTitle: "Image Resizer & Compressor",
    imageResizerSubtitle: "Resize, crop, compress and convert your images. Reduce file size without losing quality.",
    dropImageUpload: "Drop your image here or tap to upload",
    original: "Original",
    fileSize: "File Size",
    dimensions: "Dimensions",
    cropImage: "Crop Image",
    cancelCrop: "Cancel Crop",
    aspectRatio: "Aspect Ratio",
    free: "Free",
    applyCrop: "Apply Crop",
    widthPx: "Width (px)",
    heightPx: "Height (px)",
    keepAspectRatio: "Keep aspect ratio",
    qualityLabel: "Quality",
    lowQuality: "Low quality / Small size",
    highQuality: "High quality / Large size",
    outputFormat: "Output Format",
    resizeCompress: "Resize & Compress",
    newSize: "New Size",
    reduction: "Reduction",
    download: "Download",
    remove: "Remove",
    processedPreview: "Processed Preview",
    originalImage: "Original Image",
    cropModeDrag: "Crop Mode — drag to adjust",
    cropFeatureTitle: "Crop Image",
    cropFeatureDesc: "Crop your image with free or fixed aspect ratios like 1:1, 4:3, 16:9.",
    reduceFileSizeTitle: "Reduce File Size",
    reduceFileSizeDesc: "Compress images by adjusting quality. Perfect for web, email and social media.",
    customDimensionsTitle: "Custom Dimensions",
    customDimensionsDesc: "Set exact width and height in pixels, or use quick presets like 50%, 75%.",
    convertFormatTitle: "Convert Format",
    convertFormatDesc: "Convert between JPG, PNG and WebP. Choose the best format for your needs.",

    // BgRemover extra keys
    freeTool: "100% Free",
    freeToolDesc: "No limits, no watermarks, no signup required.",
    aiPowered: "AI Powered",
    aiPoweredDesc: "Smart detection of subjects, people, products and objects.",
    customColors: "Custom Colors",
    customColorsDesc: "Choose from presets or pick any custom background color.",
    openTool: "Open Tool",
    pdfEditorTool: "PDF Editor",
    pdfEditorDesc: "Edit, redact and clean PDF and image documents. Remove or replace phone numbers automatically."
  },
  
  ru: {
    // Header
    services: "Услуги",
    visaServices: "Визовые услуги",
    team: "Команда",
    teamPageHeroTitle: "Познакомьтесь с экспертами Registan Tourism",
    teamPageHeroDesc: "Наша команда специалистов по визам сделает ваши путешествия реальностью. Многолетний опыт и стремление к совершенству гарантируют гладкое оформление визы для вас.",
    teamPageLoading: "Загрузка команды...",
    teamPageViewProfile: "Открыть профиль",
    teamPageNavTours: "Туры",
    reviews: "Отзывы",
    login: "Войти",
    signUp: "Регистрация",
    logout: "Выйти",
    dashboard: "Кабинет",
    
    // Hero
    heroTitle: "РЕГИСТАН ТУРИЗМ",
    heroSubtitle: "Умные визовые решения для ОАЭ",
    visasProcessed: "ВИЗ ОФОРМЛЕНО",
    fastProcessing: "БЫСТРОЕ ОФОРМЛЕНИЕ",
    successRate: "УСПЕШНОСТЬ",
    
    // Services
    ourVisaServices: "НАШИ ВИЗОВЫЕ УСЛУГИ",
    ourServices: "НАШИ УСЛУГИ",
    catAll: "Все",
    catVisa: "Виза",
    catBusiness: "Бизнес",
    popularTours: "Популярные туры, которые посещают чаще всего",
    freelanceVisa: "Фриланс Виза",
    visaChange: "Смена Визы",
    bookNow: "Забронировать",
    businessDays: "рабочих дней",
    hours: "часов",
    
    // Service Names
    dubaiVisa14Days: "Виза Дубай 14 дней",
    dubaiVisa30Days: "Виза Дубай",
    touristVisa: "Туристическая виза",
    dubaiVisa60Days: "Виза Дубай 60 дней",
    freelanceVisaName: "Фриланс Виза",
    visaChange30Days: "Смена визы 30 дней",
    visaChange60Days: "Смена визы",
    dubaiVisa: "Виза Дубай",
    
    // Service Descriptions
    desc14Days: "Туристическая виза действительна 14 дней с даты въезда",
    desc30Days: "Быстрые и надежные туристические визы ОАЭ на 30 и 60 дней с простыми требованиями и профессиональной поддержкой. Подавайте с уверенностью и путешествуйте без стресса.",
    desc60Days: "Долгосрочная туристическая виза на 60 дней",
    descFreelance: "Профессиональное разрешение на работу фрилансера",
    descVisaChange30: "Экспресс смена визы на 30 дней на автомобиле",
    descVisaChange60: "Смените визу ОАЭ быстро и безопасно на автомобиле, автобусе или самолете. Быстрое оформление, юридическое соответствие и сервис без хлопот. Бронируйте легко и оставайтесь спокойны.",
    
    // Booking Modal
    bookYourVisaService: "Забронируйте визовую услугу",
    selectTravelDate: "Выберите дату поездки",
    chooseTravelDate: "Выберите предполагаемую дату поездки или оформления визы",
    yourInfoAndDocs: "Ваши данные и документы",
    provideDetails: "Пожалуйста, укажите ваши данные и загрузите необходимые документы",
    fullName: "Полное имя",
    enterFullName: "Введите ваше полное имя",
    whatsappPhone: "WhatsApp / Телефон",
    emailAddress: "Email адрес",
    uploadDocuments: "Загрузить документы",
    passportCopy: "Копия паспорта",
    personalPhoto: "Личное фото",
    clickToUpload: "Нажмите для загрузки",
    confirmBooking: "Подтвердите бронирование",
    reviewDetails: "Пожалуйста, проверьте детали бронирования",
    service: "Услуга",
    travelDate: "Дата поездки",
    yourInfo: "Ваши данные",
    uploadedDocs: "Загруженные документы",
    confirmationNote: "Мы свяжемся с вами в течение 24 часов через WhatsApp для подтверждения бронирования и предоставления реквизитов для оплаты.",
    next: "Далее",
    back: "Назад",
    confirm: "Подтвердить",
    submitting: "Отправка...",
    
    // Reviews
    customerReviews: "Отзывы клиентов",
    leaveReview: "Оставить отзыв",
    writeReview: "Напишите ваш отзыв",
    submitReview: "Отправить отзыв",
    
    // Footer
    yourTrustedPartner: "Ваш надежный визовый партнер в ОАЭ",
    goodToKnow: "Полезно знать",
    bookingPolicy: "Политика бронирования",
    bookingPolicyText: "Подтверждение бронирования в течение 24 часов. Оплата требуется до обработки.",
    allRightsReserved: "Все права защищены",
    privacyPolicy: "Политика конфиденциальности",
    joinTelegram: "Telegram канал",
    faq: "FAQ",
    viewSteps: "Этапы визы",
    visaStatus: "Статус визы",
    myTransactions: "Мои транзакции",
    chatAI: "Чат ИИ",
    chatAiGreeting: "Здравствуйте! Чем могу помочь?",
    chatApplyServices: "Подать заявку на услуги",
    chatApplyServicesDesc: "Просмотр и подача заявок на визовые услуги",
    chatCheckStatus: "Проверить статус",
    chatCheckStatusDesc: "Отследить заявку на визу",
    chatCallAdmin: "Написать администратору",
    chatCallAdminDesc: "Отправить сообщение администратору",
    chatWriteToAdmin: "Напишите ваше сообщение, и мы передадим его администратору. Он ответит как можно скорее.",
    chatMessageSentAdmin: "Ваше сообщение отправлено администратору. Пожалуйста, подождите, он скоро ответит...",
    chatAdminReply: "Администратор",
    chatWriteMessagePlaceholder: "Напишите сообщение администратору...",
    chatWriteMorePlaceholder: "Отправить ещё сообщение...",
    // Visa result labels (VisaChecker)
    vrLabel_VF: "Виза не нужна",
    vrDesc_VF: "Виза не требуется. Вы можете путешествовать свободно.",
    vrLabel_VOA: "Виза по прибытии",
    vrDesc_VOA: "Вы можете получить визу по прибытии в аэропорт.",
    vrLabel_ETA: "ETA",
    vrDesc_ETA: "Требуется электронное разрешение на поездку до вылета.",
    vrLabel_EV: "Электронная виза",
    vrDesc_EV: "Оформите электронную визу онлайн перед поездкой.",
    vrLabel_VR: "Требуется виза",
    vrDesc_VR: "Необходимо подать заявление на визу в посольстве или консульстве.",
    vrLabel_NA: "Въезд запрещён",
    vrDesc_NA: "Въезд для этого паспорта не разрешён.",
    vrLabel_SAME: "Одна и та же страна",
    vrDesc_SAME: "Паспорт и направление — одна и та же страна.",
    chatSelectService: "Пожалуйста, выберите услугу:",
    chatAiRedirecting: "Перенаправляю вас...",
    chatTouristVisa: "Туристическая виза",
    chatTouristVisaDesc: "Подать заявку на туристическую визу в Дубай",
    chatVisaChange: "Смена визы",
    chatVisaChangeDesc: "Изменить текущий визовый статус",
    chatFreelanceVisa: "Фрилансерская виза",
    chatFreelanceVisaDesc: "Получить фрилансерскую визу в Дубае",
    chatTours: "Туры",
    chatToursDesc: "Туры и развлечения в Дубае",
    // Business Booking Modal
    bbmStep1Title: "Название компании",
    bbmStep2Title: "Ваше имя",
    bbmStep3Title: "Гражданство",
    bbmStep4Title: "Номер мобильного телефона",
    bbmStep5Title: "Адрес электронной почты",
    bbmStep6Title: "Личное фото",
    bbmStep7Title: "Копия паспорта",
    bbmStep8Title: "Проверка и отправка",
    bbmStepOf: "Шаг",
    bbmCompanyName: "Название компании",
    bbmCompanyPlaceholder: "напр. Bright Horizons LLC",
    bbmCompanyHint: "Выберите уникальное название для вашей компании",
    bbmNationalityHint: "Как указано в паспорте",
    bbmMobileHint: "Включая код страны (напр. +971)",
    bbmEmailHint: "Мы отправим подтверждение на этот адрес",
    bbmPhotoNote: "Загрузите чёткое актуальное фото на паспорт. Необязательно — можно отправить позже.",
    bbmPassportNote: "Загрузите скан/фото страницы с данными паспорта. Необязательно — можно отправить позже.",
    bbmWantVisa: "Включить инвесторскую визу",
    uploadPhoto: "Нажмите, чтобы загрузить фото",
    uploadPassport: "Нажмите, чтобы загрузить паспорт",
    photoFormat: "JPG или PNG, до 5 МБ",
    passportFormat: "JPG, PNG или PDF, до 5 МБ",
    changePhoto: "Изменить",
    changeFile: "Изменить",
    businessSuccessText: "Мы получили ваш запрос. Наша команда свяжется с вами в течение 24 часов.",
    applicationSubmitted: "Заявка отправлена!",
    submitApplication: "Отправить заявку",
    fullName: "Полное имя",
    investorVisa: "Инвесторская виза",
    total: "Итого",
    yes: "Да",
    no: "Нет",
    zone: "Тип",
    chatAskReference: "Пожалуйста, введите номер бронирования:",
    chatAskReferenceForAdmin: "Пожалуйста, введите номер бронирования, чтобы администратор мог вам помочь:",
    chatAdminMessageReady: "Спасибо, {name}! Теперь напишите ваше сообщение, и мы передадим его администратору.",
    chatAskPassport: "Бронирование найдено! Введите номер паспорта для проверки:",
    chatBookingNotFound: "Бронирование не найдено. Проверьте номер и попробуйте снова.",
    chatPassportMismatch: "Номер паспорта не совпадает. Попробуйте снова.",
    chatWelcome: "Добро пожаловать",
    chatCurrentStatus: "Текущий статус",
    chatAgent: "Агент",
    chatWhoIsMyAgent: "Кто мой агент?",
    chatYourAgent: "Ваш агент",
    chatAskAgentNumber: "Узнать номер агента",
    chatAgentNumber: "Номер агента",
    chatAskQuestion: "Спросите о вашей визе...",
    chatSendToAdmin: "Отправить админу",
    chatSentToAdmin: "Ваше сообщение отправлено админу. Они свяжутся с вами в ближайшее время.",
    chatSentLabel: "Отправлено админу",
    chatOfferAdmin: "Хотите, чтобы я отправил ваше сообщение админу? Напишите чётко, что вам нужно, и я перешлю.",
    chatBackToMenu: "Назад в меню",
    chatRefPlaceholder: "напр. RAMIZ20260001",
    chatPassportPlaceholder: "напр. FA3204764",
    chatError: "Что-то пошло не так. Попробуйте снова.",
    chatOnline: "Онлайн",
    chatApprovedDocs: "Утверждённые документы",
    chatVoiceListen: "Прослушать статус",
    chatVoiceStop: "Стоп",
    startBusiness: "Открыть бизнес",
    home: "Главная",
    tours: "Туры",
    about: "О нас",

    // Tours Page
    tourHeroBadge: "Туры и развлечения в Дубае",
    tourHeroTitle: "Откройте для себя лучшее в Дубае",
    tourHeroDesc: "Сафари по пустыне, билеты на Бурдж-Халифу, водные мотоциклы, экскурсии по городу, круизы с ужином и многое другое — по лучшим ценам от Registan Tourism.",
    tourBookViaWhatsApp: "Забронировать через WhatsApp",
    tourAll: "Все",
    tourLoading: "Загрузка туров...",
    tourNoTours: "Туры не найдены",
    tourCheckBack: "Скоро здесь появятся захватывающие туры по Дубаю!",
    tourBookNow: "Забронировать",
    tourWhyTitle: "Почему стоит бронировать туры в Дубае с Registan Tourism?",
    tourBestPrice: "Гарантия лучшей цены",
    tourBestPriceDesc: "Мы предлагаем самые конкурентные цены на все туры и развлечения в Дубае. Без скрытых комиссий.",
    tourExpertGuides: "Опытные местные гиды",
    tourExpertGuidesDesc: "Все туры проводят сертифицированные местные гиды, которые знают Дубай изнутри.",
    tourFlexibleBooking: "Гибкое бронирование",
    tourFlexibleBookingDesc: "Бесплатная отмена за 24 часа. Возможность забронировать сейчас, оплатить позже.",
    tourWhatsAppSupport: "Поддержка 24/7 в WhatsApp",
    tourWhatsAppSupportDesc: "Мгновенное бронирование и поддержка в WhatsApp. Мы отвечаем за считанные минуты.",
    tourReadyTitle: "Готовы к приключениям в Дубае?",
    tourReadyDesc: "Свяжитесь с нами в WhatsApp для мгновенного бронирования, индивидуальных туров и групповых скидок.",
    tourBookTour: "Забронировать тур",
    tourGuestName: "Имя гостя",
    tourBookingDate: "Дата бронирования",
    tourNumberOfPeople: "Количество человек",
    tourMobileNumber: "Номер телефона",
    tourEmailAddress: "Электронная почта",
    tourCurrentLocation: "Текущее местоположение",
    tourFullName: "Полное имя",
    tourHotelOrArea: "Название отеля или район",
    tourPricePerPerson: "Цена за человека",
    tourPeople: "Человек",
    tourTotal: "Итого",
    tourCancel: "Отмена",
    tourSubmitBooking: "Отправить бронирование",
    tourSubmitting: "Отправка...",
    tourBookingSubmitted: "Бронирование отправлено!",
    tourBookingThankYou: "Ваше бронирование получено. Наша команда свяжется с вами в ближайшее время.",
    tourDone: "Готово",

    // FAQ Page
    backToHome: "На главную",
    faqTitle: "Часто задаваемые вопросы",
    faqSubtitle: "Найдите ответы на частые вопросы о наших визовых услугах, сроках обработки и многом другом.",
    stillHaveQuestions: "Остались вопросы?",
    contactUsAnytime: "Наша команда доступна 24/7 для помощи с любыми запросами.",
    
    // Booking Card
    open: "Открыто",
    closesAt: "Закрывается в",
    contactUs: "Связаться",
    whatsapp: "WhatsApp",
    callNow: "Позвонить",
    
    // Auth
    welcomeBack: "С возвращением",
    signInAccess: "Войдите для доступа к бронированиям и личному кабинету",
    createAccount: "Создать аккаунт",
    joinUs: "Присоединяйтесь для бронирования визовых услуг",
    password: "Пароль",
    enterPassword: "Введите пароль",
    forgotPassword: "Забыли пароль?",
    signIn: "Войти",
    dontHaveAccount: "Нет аккаунта?",
    alreadyHaveAccount: "Уже есть аккаунт?",
    
    // Dashboard
    myBookings: "Мои бронирования",
    myReviews: "Мои отзывы",
    profile: "Профиль",
    noBookings: "Бронирований пока нет",
    home: "Главная",
    transactions: "Транзакции",
    approved: "Одобрено",
    
    // Common
    loading: "Загрузка...",
    error: "Ошибка",
    success: "Успешно",
    cancel: "Отмена",
    save: "Сохранить",
    delete: "Удалить",
    edit: "Редактировать",
    view: "Просмотр",
    download: "Скачать",
    remove: "Удалить",
    // Booking form
    firstName: "Имя",
    lastName: "Фамилия",
    dateOfPlanning: "Дата планирования",
    nationality: "Национальность",
    selectNationality: "Выберите национальность",
    selectVisaDuration: "Выберите срок визы",
    chooseVisaDuration: "Выберите предпочтительный срок визы",
    chooseTransport: "Как вы хотите сделать визаран?",
    selectTransportMethod: "Пожалуйста, выберите один вариант",
    readingPassport: "Чтение данных паспорта...",
    passportDataExtracted: "Данные паспорта извлечены — вы можете исправить, если неверно",
    dateOfBirth: "Дата рождения",
    passportNumber: "Номер паспорта",
    // Visa Checker
    visaChecker: "Проверка визы",
    visaCheckerDesc: "Проверьте визовые требования для любой страны мира",
    yourCitizenship: "Ваше гражданство",
    destination: "Место назначения",
    selectCountry: "Выберите страну...",
    checkVisa: "Проверить визовые требования",
    checking: "Проверяем...",
    sameCountryError: "Гражданство и место назначения не могут совпадать",
    visaCheckError: "Не удалось проверить визовые требования. Попробуйте ещё раз.",
    stayDuration: "Срок пребывания",
    applyNow: "Подать заявку",
    applyForVisa: "Заявка на визу",
    applicationSent: "Заявка отправлена!",
    applicationSentDesc: "Мы свяжемся с вами в ближайшее время по поводу вашей визовой заявки.",
    submitApplication: "Отправить заявку",
    areYouUAEResident: "Вы резидент ОАЭ?",
    enterEmail: "Введите ваш email",
    submitting: "Отправка...",
    done: "Готово",
    yes: "Да",
    no: "Нет",
    // SEO Content
    seoDubaiTitle: "Виза в Дубай — Оформите онлайн туристическую визу в ОАЭ",
    seoDubaiP1: "Registan Tourism — это надёжный визовый сервис, который помогает тысячам путешественников быстро и доступно оформить визу в Дубай. Будь то краткосрочная 14-дневная туристическая виза, стандартная 30-дневная виза в ОАЭ или продлённая 60-дневная виза, мы берём на себя весь процесс — от проверки документов до подачи заявки. Наша команда обеспечивает быструю обработку за 3–5 рабочих дней, чтобы вы могли спланировать поездку в Объединённые Арабские Эмираты с уверенностью.",
    seoDubaiP2: "Оформить туристическую визу в Дубай онлайн ещё никогда не было так просто. Загрузите паспорт, и наша умная OCR-система автоматически считает данные: гражданство, дату рождения, номер паспорта, дату выдачи и срок действия. Мы проверяем, что паспорт действителен не менее шести месяцев, обеспечивая полное соответствие иммиграционным требованиям ОАЭ. Наш сервис работает для всех национальностей, и мы предоставляем отслеживание статуса визы в реальном времени.",
    seoDubaiP3: "Дубай — один из самых посещаемых городов мира, привлекающий миллионы туристов ежегодно для бизнеса, отдыха и транзита. С Registan Tourism вы получаете конкурентные цены: от 350 AED за 14-дневную визу, 500 AED за 30-дневную и 800 AED за 60-дневную визу. Наша команда поддержки доступна через WhatsApp и онлайн-чат, чтобы ответить на все вопросы о визовых требованиях ОАЭ, правилах въезда и документации. Закажите визу в Дубай сегодня и наслаждайтесь комфортным путешествием в ОАЭ.",
    seoVisaChangeTitle: "Визаран в ОАЭ — На машине, автобусе или самолёте",
    seoVisaChangeP1: "Нужно обновить или изменить визовый статус в ОАЭ? Registan Tourism предлагает полный сервис визарана, который позволяет выехать и вернуться в страну для получения новой визы. Мы предоставляем три удобных варианта: визаран на машине в Оман, визаран на автобусе или визаран на самолёте. Каждый способ полностью координируется нашей опытной командой, чтобы вы прошли процесс без каких-либо осложнений.",
    seoVisaChangeP2: "Визаран на машине — самый популярный вариант: комфортная поездка до границы с Оманом и обратно за несколько часов. Для тех, кто предпочитает бюджетный вариант, наш автобусный сервис предлагает доступный визаран с профессиональной координацией на каждом этапе. Если вам нужен быстрый вариант или вы предпочитаете перелёт, визаран на самолёте — самый быстрый способ. Все варианты включают продление визы на 30 и 60 дней, цены начинаются от 750 AED за 30-дневный визаран на автобусе.",
    seoVisaChangeP3: "Процесс визарана в ОАЭ необходим для резидентов и гостей, которым нужно сменить тип визы, продлить пребывание или обновить визу. Registan Tourism упрощает этот процесс с прозрачными ценами, обновлениями в реальном времени и координацией от двери до двери. Наша система бронирования мгновенно рассчитывает стоимость на основе срока визы и способа поездки. Будь вы турист, фрилансер или бизнесмен в Дубае, Абу-Даби или любом другом эмирате — мы предоставим надёжный визаран, который сэкономит ваше время. Свяжитесь с нами сегодня.",
    enterNamePassport: "Введите ваше имя, как указано в паспорте",
    selectTravelDate: "Выберите планируемую дату поездки",
    days: "Дней",
    // Dubai Visa Steps
    dubaiStep1Title: "Как подать заявку?",
    dubaiStep1Desc: "Эта виза должна быть оформлена, пока вы находитесь за пределами ОАЭ, чтобы получить одобрение.",
    dubaiStep2Title: "Каков срок действия визы?",
    dubaiStep2Desc: "После одобрения визы — будь то на 30 или 60 дней — вы можете въехать в ОАЭ в любое время до истечения срока визы. После въезда в ОАЭ отсчет срока визы начинается с даты въезда: виза на 30 дней дает 29 дней пребывания, а виза на 60 дней — 58 дней.",
    dubaiStep3Title: "Можно ли продлить визу?",
    dubaiStep3Desc: "Да, вы можете продлить визу внутри ОАЭ, не покидая страну. Визу на 30 дней можно продлить не более 2 раз.",
    // Visa Change Steps
    vcStep1Title: "Выберите способ поездки",
    vcStep1Desc: "Выберите, как вы хотите сделать смену визы: на автомобиле до границы Омана, на автобусе или на самолёте. Каждый способ имеет разные сроки и стоимость.",
    vcStep2Title: "Загрузите документы",
    vcStep2Desc: "Загрузите копию паспорта и личное фото. Наша команда подготовит все необходимые документы для смены визы.",
    vcStep3Title: "Поездка и обработка на границе",
    vcStep3Desc: "Поездка до границы или аэропорта по плану. Наш агент поможет вам на всём пути — выезд и повторный въезд.",
    vcStep4Title: "Новая виза выдана",
    vcStep4Desc: "После повторного въезда новая виза проштампована и активирована. Вы получите подтверждение с данными новой визы.",
    // Family Visa Steps
    familyVisaName: "Семейная виза",
    familyVStep1Title: "Выберите члена семьи",
    familyVStep1Desc: "Выберите, для кого вы хотите оформить семейную визу: муж, жена, сын, дочь или мать.",
    familyVStep2Title: "Загрузите документы",
    familyVStep2Desc: "Загрузите копию паспорта и личное фото члена семьи, для которого оформляется виза.",
    familyVStep3Title: "Предварительный просмотр Emirates ID",
    familyVStep3Desc: "Наша система создаёт предварительный просмотр Emirates ID по данным паспорта. Проверьте правильность всех данных.",
    familyVStep4Title: "Контактная информация",
    familyVStep4Desc: "Укажите номер WhatsApp и электронную почту, чтобы мы могли связаться с вами по статусу заявки.",
    familyVStep5Title: "Проверка и подтверждение",
    familyVStep5Desc: "Проверьте все данные вашей заявки на семейную визу и подтвердите отправку. Вы получите номер для отслеживания статуса.",
    
    // Freelance Visa Steps
    freelanceVStep1Title: "Подача заявки",
    freelanceVStep1Desc: "Заполните личные данные, загрузите копию паспорта и фото. Наша команда начнёт обработку вашей фриланс визы.",
    freelanceVStep2Title: "Виза одобрена",
    freelanceVStep2Desc: "Ваша заявка на фриланс визу рассмотрена и одобрена. Вы получите подтверждение с документом об одобрении визы.",
    freelanceVStep3Title: "Смена опции",
    freelanceVStep3Desc: "Ваш визовый статус обновлён в системе. Необходимые изменения опции обработаны для вашего фрилансерского разрешения.",
    freelanceVStep4Title: "Медицинский тест",
    freelanceVStep4Desc: "Пройдите обязательный медицинский осмотр в утверждённом медцентре. Результаты передаются в иммиграционную службу.",
    freelanceVStep5Title: "Резидентская виза",
    freelanceVStep5Desc: "Ваша резидентская виза ОАЭ выдана. Она позволяет легально жить и работать в ОАЭ в качестве фрилансера.",
    freelanceVStep6Title: "Emirates ID",
    freelanceVStep6Desc: "Ваш Emirates ID обработан и выдан. Это ваш официальный документ, удостоверяющий личность в ОАЭ.",

    // Modal Common
    howItWorks: "Как это работает",
    gotIt: "Понятно",

    // Dashboard Page
    loadingDashboard: "Загрузка личного кабинета...",
    noBookingsYet: "Нет бронирований",
    noBookingsDesc: "У вас пока нет бронирований. Изучите наши визовые услуги!",
    browseServices: "Смотреть услуги",
    total: "всего",
    nameLabel: "Имя",
    nationalityLabel: "Национальность",
    passportNumberLabel: "№ паспорта",
    travelDateLabel: "Дата поездки",
    priceLabel: "Цена",
    bookedLabel: "Забронировано",
    yourDocuments: "Ваши документы",
    passport: "Паспорт",
    photo: "Фото",
    documentFromRegistan: "Документ от Регистан Туризм",
    downloadDocument: "Скачать документ",
    weWillContact: "Мы свяжемся с вами по номеру",
    contactViaWhatsApp: "Связаться через WhatsApp",
    deleteBookingTitle: "Удалить бронирование?",
    deleteWarning: "Внимание: Это действие нельзя отменить!",
    deleteInfo: "Вы собираетесь удалить бронирование:",
    deletePermanent: "Это бронирование и все связанные документы будут удалены навсегда.",
    yesDeleteForever: "Да, удалить навсегда",
    deleting: "Удаление...",
    noReviewsYet: "Нет отзывов",
    noReviewsDesc: "Вы ещё не оставляли отзывов. Поделитесь своим опытом!",
    rating: "Рейтинг",
    review: "Отзыв",
    saveChanges: "Сохранить изменения",
    editPhoto: "Изменить фото",
    updateProfilePhoto: "Обновить фото профиля",
    uploadPhotoOrAvatar: "Загрузите фото или выберите аватар",
    uploadPhoto: "Загрузить фото",
    chooseAvatar: "Выбрать аватар",
    removePhoto: "Удалить фото",
    uploading: "Загрузка...",
    documentRequired: "Требуется документ",
    documentReuploadRequired: "Требуется повторная загрузка",
    required: "Требуется",
    reason: "Причина",
    reupload: "Загрузить заново",
    submitDocument: "Отправить документ",
    uploadingDocument: "Загрузка документа...",
    selected: "Выбрано",
    signingIn: "Вход...",
    creatingAccount: "Создание аккаунта...",
    mobileNumber: "Номер телефона",
    optional: "Необязательно",
    minChars: "Минимум 6 символов",
    joinRegistan: "Присоединяйтесь к Регистан Туризм",
    date: "Дата",
    details: "Детали",
    
    // Forgot Password
    forgotPassword: "Забыли пароль?",
    forgotPasswordTitle: "Забыли пароль?",
    forgotPasswordDesc: "Введите email, и мы отправим ссылку для сброса пароля.",
    sendResetLink: "Отправить ссылку",
    sending: "Отправка...",
    checkYourEmail: "Проверьте почту",
    resetEmailSent: "Мы отправили ссылку для сброса пароля. Проверьте входящие.",
    backToLogin: "Вернуться к входу",
    rememberPassword: "Помните пароль?",
    forgotPasswordError: "Не удалось отправить email. Попробуйте снова.",
    
    // Reset Password Page
    resetPasswordTitle: "Сброс пароля",
    resetPasswordDesc: "Введите новый пароль ниже.",
    verifyingToken: "Проверка ссылки...",
    invalidToken: "Недействительная ссылка",
    invalidTokenDesc: "Эта ссылка недействительна или истекла. Запросите новую.",
    requestNewLink: "Запросить новую ссылку",
    passwordResetSuccess: "Пароль успешно сброшен!",
    passwordResetSuccessDesc: "Ваш пароль обновлён. Перенаправление на вход...",
    goToLogin: "Перейти к входу",
    newPassword: "Новый пароль",
    confirmPassword: "Подтвердите пароль",
    enterNewPassword: "Введите новый пароль",
    confirmNewPassword: "Подтвердите новый пароль",
    resetPassword: "Сбросить пароль",
    resetting: "Сброс...",
    passwordMinLength: "Пароль должен быть не менее 6 символов",
    passwordsNoMatch: "Пароли не совпадают",
    resetPasswordError: "Не удалось сбросить пароль. Попробуйте снова.",
    
    jpgPngPdf: "JPG, PNG или PDF (макс. 5МБ)",
    jpgPng: "JPG или PNG (макс. 5МБ)",
    clickToUploadPassport: "Нажмите для загрузки паспорта",
    clickToUploadPhoto: "Нажмите для загрузки фото",
    usingAccountEmail: "Используется email вашего аккаунта",
    star: "звезда",
    stars: "звёзд",
    
    // Step-by-Step Booking
    enterFullNamePassport: "Введите ваше полное имя как в паспорте",
    enterPhoneContact: "Введите номер WhatsApp для связи",
    enterEmailConfirmation: "Введите email для подтверждения бронирования",
    uploadPassport: "Загрузить паспорт",
    uploadPassportInstruction: "Загрузите чёткое фото паспорта. Мы автоматически извлечём вашу информацию.",
    uploadPhotoInstruction: "Загрузите чёткое личное фото для визовой заявки",
    extractingData: "Извлечение данных паспорта...",
    extractedInfo: "Извлечённая информация",
    surname: "Фамилия",
    givenNames: "Имя и отчество",
    dateOfBirth: "Дата рождения",
    nationality: "Гражданство",
    passportNumber: "Номер паспорта",
    passportExpiry: "Срок действия",
    reviewConfirm: "Проверить и подтвердить",
    reviewInstruction: "Проверьте ваши данные. Нажмите редактировать для изменений.",
    contactInfo: "Контактная информация",
    passportInfo: "Данные паспорта",
    phone: "Телефон",
    email: "Email",
    expiryDate: "Срок действия",
    issueDate: "Дата выдачи",
    notPassportError: "Это не похоже на паспорт. Пожалуйста, загрузите ваш паспорт.",
    passportExpiringSoon: "Срок действия паспорта истекает менее чем через 6 месяцев. Продлите паспорт перед подачей заявки.",
    bookingSuccess: "Бронирование успешно!",
    bookingFailed: "Ошибка бронирования. Попробуйте снова.",
    pleaseEnterName: "Пожалуйста, введите ваше имя",
    pleaseEnterPhone: "Пожалуйста, введите номер телефона",
    pleaseEnterEmail: "Пожалуйста, введите email",
    pleaseUploadPassport: "Пожалуйста, загрузите паспорт",
    pleaseUploadPhoto: "Пожалуйста, загрузите фото",
    uploadPassportSimple: "Загрузите четкую фотографию вашего паспорта",
    reviewInstruction: "Пожалуйста, проверьте ваши данные перед подтверждением.",
    // Debit Card
    debitCardQuestion: "Вам нужна дебетовая карта?",
    debitCardDescription: "Получите дебетовую карту банка ОАЭ вместе с фриланс визой за дополнительные 500 дирхамов",
    debitCard: "Дебетовая карта",
    yes: "Да",
    no: "Нет",
    skipDebitCard: "Пропустить",
    pleaseSelectDebitCard: "Пожалуйста, выберите Да или Нет",
    // PDF Number Remover
    pdfTitle: "Удаление номеров +971 из файлов",
    pdfDescription: "Загрузите PDF, JPG или PNG файл. Система автоматически найдет и удалит все номера ОАЭ (+971XXXXXXXXX) и вернет очищенный файл.",
    pdfDropzone: "Перетащите файл сюда или нажмите для выбора",
    pdfDropzoneHint: "Поддерживаются PDF, JPG, PNG (макс. 20МБ)",
    pdfYourNumber: "Ваш номер (необязательно)",
    pdfYourNumberHint: "Введите ваш номер для замены удалённых",
    pdfRemoveBtn: "Удалить номера",
    pdfProcessing: "Обработка...",
    pdfComplete: "Обработка завершена",
    pdfFoundAndReplaced: "Найдено",
    pdfNumbers: "номер(ов)",
    pdfFoundAndRemoved: "Найдено и удалено",
    pdfNoNumbers: "В вашем файле не найдено номеров +971.",
    pdfNumbersRemoved: "Удалённые номера",
    pdfDownload: "Скачать очищенный файл",
    pdfAnother: "Обработать другой файл",
    pdfSecure: "Ваши файлы обрабатываются безопасно и удаляются после скачивания",
    pdfSupports: "Поддерживаются PDF документы, JPG и PNG изображения",
    pdfOnlyFileTypes: "Пожалуйста, загрузите файл PDF, JPG или PNG.",
    pdfFileTooLarge: "Размер файла не должен превышать 20МБ.",
    pdfProcessingFailed: "Ошибка обработки файла. Попробуйте ещё раз.",
    // 404 Page
    notFoundTitle: "Кажется, вы сбились с пути",
    notFoundText: "Страница, которую вы ищете, потерялась в пустыне. Давайте вернём вас на маршрут.",
    notFoundBtn: "Вернуться на главную",
    notFoundTryLabel: "Или попробуйте:",
    goneTitle: "Эта страница удалена",
    goneText: "Эта страница больше не существует и была навсегда удалена.",
    // About Page
    aboutMetaTitle: "О Registan Tourism — Надёжные визовые услуги в Дубае и туристическое агентство ОАЭ",
    aboutMetaDesc: "Registan Tourism — ведущий поставщик визовых услуг в Дубае: туристические визы ОАЭ, смена визы, семейная виза, фриланс виза и открытие бизнеса в Дубае.",
    aboutBadge: "Офис в Дубае, ОАЭ",
    aboutHeroTitle: "Registan Tourism — Ваш надёжный визовый сервис в Дубае и туристическое агентство ОАЭ",
    aboutHeroDesc: "Мы помогаем тысячам путешественников оформить визу в Дубай онлайн, провести смену визы в ОАЭ и открыть бизнес в Эмиратах. Быстрые, надёжные и доступные визовые услуги с поддержкой 24/7.",
    aboutApplyBtn: "Подать заявку на визу",
    aboutWhatsappBtn: "Написать в WhatsApp",
    aboutStatCountries: "Стран обслужено",
    aboutStatSupport: "Поддержка клиентов",
    aboutStatApproval: "Процент одобрения",
    aboutWhoTitle: "Ваш путь в ОАЭ — построен на доверии, основан на опыте",
    aboutWhoP1: "Registan Tourism — это профессионально управляемое визовое агентство в Дубае, помогающее путешественникам из более чем 15 стран быстро и эффективно получить туристические, гостевые и транзитные визы ОАЭ. Наша команда опытных иммиграционных консультантов обеспечивает обработку каждой заявки с высочайшей точностью и в полном соответствии с иммиграционным законодательством ОАЭ.",
    aboutWhoP2: "Независимо от того, нужна ли вам виза в Дубай на 14 дней, туристическая виза ОАЭ на 30 дней или виза длительного пребывания на 60 дней — мы полностью ведём процесс от проверки документов до визовой печати. Наша система онлайн-бронирования использует технологию OCR для автоматического считывания данных паспорта.",
    aboutWhoP3: "Помимо туристических виз, мы специализируемся на услугах смены визы в ОАЭ — визараны. Смена визы на машине в Оман, на автобусе или на самолёте — гибкие и удобные варианты обновления визового статуса.",
    aboutWhoP4: "Мы также предлагаем спонсорство семейной визы в Дубае, оформление фриланс визы и бизнес-лицензии в свободных зонах ОАЭ, а также экспертные консультации по иммиграции. Наша цель — сделать визовые услуги доступными, прозрачными и удобными для всех.",
    aboutServicesTitle: "Наши визовые и туристические услуги в Дубае",
    aboutServicesSubtitle: "Комплексные визовые и иммиграционные решения для туристов, резидентов и бизнеса в ОАЭ",
    aboutSvcVisaTitle: "Туристическая виза Дубай",
    aboutSvcVisaDesc: "Туристические визы ОАЭ на 14, 30 и 60 дней с быстрой обработкой за 3-5 рабочих дней.",
    aboutSvcChangeTitle: "Смена визы",
    aboutSvcChangeDesc: "Удобная смена визы на машине, автобусе или самолёте с координацией пограничного перехода.",
    aboutSvcFamilyTitle: "Семейная виза ОАЭ",
    aboutSvcFamilyDesc: "Спонсирование мужа, жены, сына, дочери или матери для семейной резидентской визы ОАЭ.",
    aboutSvcBusinessTitle: "Открытие бизнеса в Дубае",
    aboutSvcBusinessDesc: "Полное оформление фриланс визы и бизнес-лицензии в свободных зонах Дубая.",
    aboutSvcConsultTitle: "Визовая консультация",
    aboutSvcConsultDesc: "Экспертная помощь по иммиграции ОАЭ, типам виз, требованиям и документации.",
    aboutSvcPremiumTitle: "Премиум-сервис",
    aboutSvcPremiumDesc: "Приоритетная обработка, VIP-поддержка и личный менеджер для срочных заявок.",
    aboutWhyTitle: "Почему выбирают Registan Tourism для визы в Дубай?",
    aboutWhySubtitle: "Нам доверяют сотни путешественников по всему миру",
    aboutWhyFastTitle: "Быстрая обработка",
    aboutWhyFastDesc: "Получите визу в Дубай за 3-5 рабочих дней благодаря нашей отлаженной системе.",
    aboutWhyTrustedTitle: "Надёжный и лицензированный",
    aboutWhyTrustedDesc: "Авторизованный поставщик визовых услуг, зарегистрированный в ОАЭ с многолетним опытом.",
    aboutWhyApprovalTitle: "Высокий процент одобрения",
    aboutWhyApprovalDesc: "99% одобрения виз благодаря тщательной проверке документов и соблюдению требований.",
    aboutWhyReviewsTitle: "5-звёздочные отзывы",
    aboutWhyReviewsDesc: "Сотни довольных клиентов по всему миру доверяют Registan Tourism для оформления виз.",
    aboutWhyWhatsappTitle: "Поддержка WhatsApp 24/7",
    aboutWhyWhatsappDesc: "Мгновенная помощь в любое время через WhatsApp, чат или email от нашей многоязычной команды.",
    aboutWhyLocalTitle: "Офис в Дубае",
    aboutWhyLocalDesc: "Присутствие в Дубае с глубоким знанием визовых правил и иммиграционной политики ОАЭ.",
    aboutCtaTitle: "Готовы подать заявку на визу в Дубай?",
    aboutCtaDesc: "Начните оформление визы ОАЭ сегодня. Быстрая обработка, доступные цены и персональная поддержка от нашей команды в Дубае.",
    aboutCtaBtn: "Подать заявку",
    // Chat
    startChat: "Начать чат",
    registanSupport: "Поддержка Registan",
    chatWelcome: "Добро пожаловать!",
    chatWelcomeDesc: "Введите свои данные, чтобы начать общение или продолжить предыдущий разговор.",
    yourName: "Ваше имя",
    enterYourName: "Введите ваше имя",
    phoneNumber: "Номер телефона",
    startChatBtn: "Начать чат",
    loadingChat: "Загрузка...",
    loadingMessages: "Загрузка сообщений...",
    noMessagesYet: "Сообщений пока нет. Начните разговор!",
    typeMessage: "Напишите сообщение...",
    sending: "Отправка...",
    // Admin
    addService: "Добавить услугу",
    editService: "Редактировать услугу",
    deleteBtn: "Удалить",
    editBtn: "Редактировать",
    stepsBtn: "Этапы",
    nSteps: "Этапы",
    serviceName: "Название услуги",
    price: "Цена",
    duration: "Срок",
    subtitle: "Подзаголовок",
    category: "Категория",
    description: "Описание",
    serviceImage: "Изображение услуги",
    saveChanges: "Сохранить",
    cancel: "Отмена",
    selectCategory: "Выберите категорию",
    moveUp: "Вверх",
    moveDown: "Вниз",
    
    // Family Visa
    familyVisa: "Семейная Виза",
    familyVisaName: "Семейная Виза",
    descFamilyVisa: "Привезите свою семью в ОАЭ с нашим профессиональным сервисом семейной визы. Мы занимаемся всеми документами, требованиями спонсорства и обеспечиваем плавный процесс для ваших близких.",
    whoApplyVisaFor: "Для кого вы хотите оформить визу?",
    selectFamilyMember: "Выберите члена семьи",
    husband: "Муж",
    son: "Сын",
    daughter: "Дочь",
    mother: "Мать",
    uploadPassportPhoto: "Загрузите паспорт и фото",
    uploadPassportPhotoOf: "Пожалуйста, загрузите паспорт и личное фото",
    emiratesIdPreview: "Предварительный просмотр Emirates ID",
    reviewPassportInfo: "Проверьте информацию, извлеченную из паспорта",
    firstNameLabel: "Имя",
    lastNameLabel: "Фамилия",
    dateOfBirthLabel: "Дата рождения",
    nationalityLabel: "Гражданство",
    unitedArabEmirates: "ОБЪЕДИНЕННЫЕ АРАБСКИЕ ЭМИРАТЫ",
    confirmApplication: "Подтвердить заявку",
    reviewSubmitFamilyVisa: "Пожалуйста, проверьте и отправьте заявку на семейную визу",
    applyingFor: "Виза для",
    name: "Имя",
    bySubmittingAgree: "Отправляя заявку, вы соглашаетесь с нашими условиями. Мы свяжемся с вами в течение 24 часов.",
    dataExtracted: "Данные извлечены",
    goBackUploadClear: "Пожалуйста, вернитесь и загрузите четкое фото паспорта для извлечения информации",
    clickUploadPassport: "Нажмите для загрузки паспорта",
    clickUploadPhoto: "Нажмите для загрузки фото",
    readingPassportData: "Чтение данных паспорта...",
    contactInfo: "Контактная информация",
    enterContactDetails: "Пожалуйста, введите ваши контактные данные",
    whatsappNumber: "Номер WhatsApp",
    emailAddress: "Электронная почта",
    weWillContactYou: "Мы свяжемся с вами через WhatsApp для обновлений по вашей заявке",
    telegram: "Telegram",
    telegramOptional: "Telegram (необязательно)",
    telegramOptionalHint: "Мы можем доставить ваши визовые документы прямо в Telegram после одобрения.",
    phoneOrTelegram: "Номер телефона или Telegram",
    phoneOrTelegramHint: "Напишите ваш номер телефона или Telegram, чтобы мы могли отправить документы в Telegram после одобрения.",
    phoneOrTelegramNote: "Номер WhatsApp или Telegram @username — оба варианта работают.",
    contactNumbers: "Контактные номера",
    phoneNumber: "Номер телефона",
    phoneAndTelegramHint: "Введите номер телефона и Telegram/WhatsApp, чтобы мы могли отправить одобренные документы.",
    sameNumberForTelegram: "Тот же номер для Telegram / WhatsApp",
    telegramOrWhatsapp: "Номер Telegram или WhatsApp",
    telegramShareDocsHint: "Мы отправим ваши одобренные документы на этот Telegram/WhatsApp.",
    pleaseEnterTelegram: "Введите номер Telegram или WhatsApp, или отметьте «тот же номер».",
    
    // Transport methods (for visa change)
    by: "на",
    car: "машине",
    bus: "автобусе",
    airplane: "самолёте",

    // Tourism Software Hub
    tourismSoftware: "Туристическое ПО",
    tourismSoftwareTitle: "Туристическое ПО",
    tourismSoftwareSubtitle: "Бесплатные онлайн-инструменты для путешественников, агентств и заявителей на визу",
    bgRemoverTool: "Удаление фона",
    bgRemoverDesc: "Мгновенно удаляйте фон изображения с помощью ИИ. Скачивайте в PNG или JPG с произвольным цветом.",
    dummyFlightTool: "Фиктивный авиабилет",
    dummyFlightDesc: "Создавайте реалистичные образцы авиабилетов для визовых заявок. Любой маршрут по всему миру.",
    imageResizerTool: "Изменение размера",
    imageResizerDesc: "Изменяйте размер, сжимайте и конвертируйте изображения. Уменьшайте размер файла мгновенно.",
    stampMakerTool: "Создание штампов",
    stampMakerDesc: "Создавайте профессиональные цифровые печати для деловых документов и официальных бумаг.",
    resumeBuilderTool: "Создание резюме",
    resumeBuilderDesc: "Создайте профессиональное резюме онлайн бесплатно. Выберите шаблон и скачайте в PDF.",
    stampPageH1: "Бесплатный онлайн-конструктор печатей — создайте цифровые штампы",
    stampPageH2: "Создавайте профессиональные печати для документов, счетов и официальных бумаг",
    stampPageText: "Создавайте качественные цифровые штампы мгновенно с помощью нашего бесплатного онлайн-инструмента. Нужна ли вам круглая печать компании, прямоугольный штамп утверждения или именная подпись для деловых документов — наш инструмент позволяет создать и скачать профессиональные печати за секунды. Идеально для фрилансеров, малого бизнеса и предприятий в ОАЭ и по всему миру. Выберите форму, добавьте название компании, регистрационный номер и логотип — затем скачайте штамп в формате PNG с прозрачным фоном для использования на счетах, контрактах и официальных документах. Регистрация не требуется, полностью бесплатно.",
    stampToolTitle: "Конструктор печатей",
    stampComingSoon: "Скоро — мы создаём мощный инструмент для создания печатей.",
    resumePageH1: "Профессиональный конструктор резюме — получите работу мечты в ОАЭ и по всему миру",
    resumePageH2: "Создайте впечатляющее CV, которое приведёт к трудоустройству — бесплатно, быстро и готово к скачиванию в PDF",
    resumePageText: "Резюме — это ваше первое впечатление на работодателя, и оно должно быть безупречным. Наш профессиональный конструктор резюме создан для соискателей в Дубае, Абу-Даби и по всем ОАЭ, а также для международного рынка труда. Независимо от того, являетесь ли вы опытным руководителем, специалистом, меняющим отрасль, или выпускником, начинающим карьеру — наш инструмент поможет представить ваш опыт, навыки и квалификацию в современном, профессиональном формате, который выделяется среди конкурентов. Просто введите личные данные, опыт работы, образование, языки и навыки — система мгновенно создаст отточенное, ATS-совместимое резюме для скачивания в PDF. Без регистрации, без водяных знаков, без скрытых платежей. Тысячи профессионалов на Ближнем Востоке, в Южной Азии и странах СНГ уже пользуются нашим сервисом.",
    resumeToolTitle: "Конструктор резюме",
    resumeComingSoon: "Скоро — мы создаём мощный инструмент для создания резюме.",
    // Freelance Visa Page
    fvPageH1: "Фриланс виза в Дубае 2026 — Работайте независимо в ОАЭ с полным легальным резидентством",
    fvPageH2: "Подайте заявку онлайн на разрешение фрилансера ОАЭ — Быстрое оформление, полная поддержка от Registan Tourism",
    fvPageDesc: "Начните карьеру фрилансера в Дубае с полностью легальной фриланс визой ОАЭ от Registan Tourism. Наш полный комплекс услуг включает выдачу торговой лицензии, штамповку визы, оформление Emirates ID и медицинское обследование — всё за 5-7 рабочих дней. Независимо от того, являетесь ли вы дизайнером, разработчиком, консультантом, контент-мейкером или любым другим независимым профессионалом — наша команда занимается каждым шагом, чтобы вы могли сосредоточиться на развитии бизнеса. Прозрачные цены от 5 000 AED без скрытых платежей, доставка документов до двери и отслеживание статуса в реальном времени через личный кабинет.",
    fvApplyBtn: "Подать заявку на фриланс визу",
    fvPrice: "От 5 000 AED",
    fvDuration: "Оформление: 5-7 дней",
    fvFeaturesTitle: "Что включено",
    fvFeature1: "Фриланс торговая лицензия",
    fvFeature2: "Штамповка резидентской визы ОАЭ",
    fvFeature3: "Оформление Emirates ID",
    fvFeature4: "Медицинское обследование",
    fvFeature5: "Забор и доставка документов",
    fvFeature6: "Отслеживание статуса в реальном времени",
    fvFeature7: "Персональный менеджер поддержки",
    fvFeature8: "Без скрытых платежей",
    // Resume Builder
    rbFormTitle: "Создайте резюме",
    rbPhoto: "Фото",
    rbUploadPhoto: "Загрузить фото",
    rbFullName: "Полное имя",
    rbFullNamePh: "Иван Иванов",
    rbJobTitle: "Должность",
    rbJobTitlePh: "Разработчик",
    rbMobile: "Телефон",
    rbEmail: "Эл. почта",
    rbAddress: "Адрес",
    rbAddressPh: "Дубай, ОАЭ",
    rbAboutMe: "Обо мне",
    rbAboutMePh: "Напишите кратко о себе...",
    rbWorkExp: "Опыт работы",
    rbPosition: "Должность",
    rbCompany: "Компания",
    rbCountry: "Страна",
    rbFromYear: "С (год)",
    rbToYear: "По (год)",
    rbPresent: "По настоящее время",
    rbAddWork: "Добавить опыт",
    rbEducation: "Образование",
    rbInstitution: "Учебное заведение",
    rbCity: "Город",
    rbAddEdu: "Добавить образование",
    rbSkills: "Навыки",
    rbSkillPh: "напр. React, Photoshop",
    rbLanguages: "Языки",
    rbLangPh: "напр. Английский",
    rbHobbies: "Хобби",
    rbHobbyPh: "напр. Фотография",
    rbSocialLinks: "Соц. сети",
    rbLinkText: "Текст ссылки (напр. Мой сайт)",
    rbDownloadPDF: "Скачать PDF",
    rbDownloading: "Создание PDF...",
    rbDesignStyle: "Стиль дизайна",
    rbClassic: "Классический",
    rbModern: "Современный",
    rbCreative: "Креативный",
    rbYourName: "Ваше имя",
    rbCreateResume: "Создать резюме",
    rbFreeForever: "ВСЕГДА БЕСПЛАТНО",
    rbBadge1: "Без регистрации",
    rbBadge2: "ATS-совместимый формат",
    rbBadge3: "Используется по всему миру",

    // Background Remover Page
    bgRemoverTitle: "Удаление фона",
    bgRemoverSubtitle: "Мгновенно удаляйте фон изображения с помощью ИИ. Загрузите любое фото и скачайте с прозрачным или цветным фоном.",
    uploadImage: "Загрузить изображение",
    dropImageHere: "Перетащите изображение сюда или нажмите для загрузки",
    supportedFormats: "PNG, JPG, WEBP до 10МБ",
    processing: "Обработка...",
    removingBackground: "Удаление фона...",
    downloadPNG: "Скачать PNG",
    downloadJPG: "Скачать JPG",
    bgColor: "Цвет фона",
    transparent: "Прозрачный",
    removeAnother: "Удалить другой",

    // KeyFlight Page
    flightTicketGenerator: "Генератор авиабилетов",
    flightTicketSubtitle: "Создавайте профессиональные электронные билеты для визовых заявок. Выберите любой маршрут.",
    passengerName: "Имя пассажира",
    tripType: "Тип поездки",
    oneWay: "В одну сторону",
    roundTrip: "Туда и обратно",
    from: "Откуда",
    to: "Куда",
    departureDate: "Дата вылета",
    returnDate: "Дата возврата",
    searchFlights: "Найти рейсы",
    selectYourFlight: "Выберите рейс",
    outboundFlights: "Рейсы туда",
    returnFlights: "Рейсы обратно",
    generateTicket: "Создать билет",
    back: "Назад",
    yourTicketReady: "Ваш электронный билет готов!",
    downloadETicket: "Скачать электронный билет",
    sendToEmail: "Отправить на почту",
    generateNew: "Создать новый",
    sendTicketTitle: "Отправить билет на почту",
    sendTicketDesc: "Введите адрес электронной почты для получения электронного билета.",
    sendETicket: "Отправить билет",
    sending: "Отправка...",
    ticketSentSuccess: "Электронный билет успешно отправлен!",

    // Image Resizer Page
    imageResizerTitle: "Изменение размера и сжатие",
    imageResizerSubtitle: "Изменяйте размер, обрезайте, сжимайте и конвертируйте изображения. Уменьшайте размер файла без потери качества.",
    dropImageUpload: "Перетащите изображение сюда или нажмите для загрузки",
    original: "Оригинал",
    fileSize: "Размер файла",
    dimensions: "Размеры",
    cropImage: "Обрезать",
    cancelCrop: "Отменить обрезку",
    aspectRatio: "Соотношение сторон",
    free: "Свободное",
    applyCrop: "Применить обрезку",
    widthPx: "Ширина (пикс)",
    heightPx: "Высота (пикс)",
    keepAspectRatio: "Сохранить пропорции",
    qualityLabel: "Качество",
    lowQuality: "Низкое качество / Малый размер",
    highQuality: "Высокое качество / Большой размер",
    outputFormat: "Формат вывода",
    resizeCompress: "Изменить и сжать",
    newSize: "Новый размер",
    reduction: "Уменьшение",
    download: "Скачать",
    remove: "Удалить",
    processedPreview: "Обработанный предпросмотр",
    originalImage: "Оригинальное изображение",
    cropModeDrag: "Режим обрезки — перетащите для настройки",
    cropFeatureTitle: "Обрезка изображения",
    cropFeatureDesc: "Обрезайте изображение со свободным или фиксированным соотношением сторон: 1:1, 4:3, 16:9.",
    reduceFileSizeTitle: "Уменьшение размера",
    reduceFileSizeDesc: "Сжимайте изображения, регулируя качество. Идеально для веб-сайтов, почты и соцсетей.",
    customDimensionsTitle: "Произвольные размеры",
    customDimensionsDesc: "Задайте точную ширину и высоту в пикселях или используйте пресеты 50%, 75%.",
    convertFormatTitle: "Конвертация формата",
    convertFormatDesc: "Конвертируйте между JPG, PNG и WebP. Выберите лучший формат для ваших нужд.",

    // BgRemover extra keys
    freeTool: "100% бесплатно",
    freeToolDesc: "Без ограничений, без водяных знаков, без регистрации.",
    aiPowered: "ИИ технология",
    aiPoweredDesc: "Умное определение людей, предметов и объектов на фото.",
    customColors: "Пользовательские цвета",
    customColorsDesc: "Выбирайте из готовых или подберите любой цвет фона.",
    openTool: "Открыть",
    pdfEditorTool: "PDF редактор",
    pdfEditorDesc: "Редактируйте и очищайте PDF и изображения. Автоматически удаляйте номера телефонов."
  },
  
  uz: {
    // Header
    services: "Xizmatlar",
    visaServices: "Viza xizmatlari",
    team: "Jamoa",
    teamPageHeroTitle: "Registan Tourism orqasidagi mutaxassislar bilan tanishing",
    teamPageHeroDesc: "Viza bo'yicha bag'rikeng mutaxassislardan iborat jamoamiz sayohat orzularingizni amalga oshirish uchun shu yerda. Ko'p yillik tajriba va mukammallikka sodiqligimiz tufayli sizga muammosiz viza jarayonini taqdim etamiz.",
    teamPageLoading: "Jamoa yuklanmoqda...",
    teamPageViewProfile: "Profilni ko'rish",
    teamPageNavTours: "Sayohatlar",
    reviews: "Sharhlar",
    login: "Kirish",
    signUp: "Ro'yxatdan o'tish",
    logout: "Chiqish",
    dashboard: "Kabinet",
    
    // Hero
    heroTitle: "REGISTON TURIZM",
    heroSubtitle: "BAA uchun aqlli viza yechimlari",
    visasProcessed: "VIZALAR RASMIYLASHTIRILDI",
    fastProcessing: "TEZKOR XIZMAT",
    successRate: "MUVAFFAQIYAT",
    
    // Services
    ourVisaServices: "BIZNING VIZA XIZMATLARIMIZ",
    ourServices: "BIZNING XIZMATLARIMIZ",
    catAll: "Barchasi",
    catVisa: "Viza",
    catBusiness: "Biznes",
    popularTours: "Ko'p odamlar tashrif buyuradigan mashhur turlar",
    freelanceVisa: "Frilanser Vizasi",
    visaChange: "Viza Almashtirish",
    bookNow: "Buyurtma berish",
    businessDays: "ish kuni",
    hours: "soat",
    
    // Service Names
    dubaiVisa14Days: "Dubay Vizasi 14 kun",
    dubaiVisa30Days: "Dubay Vizasi",
    touristVisa: "Turistik viza",
    dubaiVisa60Days: "Dubay Vizasi 60 kun",
    freelanceVisaName: "Frilanser Vizasi",
    visaChange30Days: "30 kunlik Viza Almashtirish",
    visaChange60Days: "Viza Almashtirish",
    dubaiVisa: "Dubay Vizasi",
    
    // Service Descriptions
    desc14Days: "Kirish sanasidan 14 kun amal qiladigan turist vizasi",
    desc30Days: "30 va 60 kunlik BAA turistik vizalari — oddiy talablar va professional yordam bilan tez va ishonchli. Ishonch bilan ariza bering va xotirjam sayohat qiling.",
    desc60Days: "60 kunlik uzoq muddatli turist vizasi",
    descFreelance: "Professional frilanser ish ruxsatnomasi va vizasi",
    descVisaChange30: "Avtomobil orqali 30 kunlik tezkor viza almashtirish",
    descVisaChange60: "BAA vizangizni avtomobil, avtobus yoki samolyot orqali tez va xavfsiz almashtiring. Tezkor rasmiylashtirish, qonuniy muvofiqlik va muammosiz xizmat. Oson bron qiling va xotirjam bo'ling.",
    
    // Booking Modal
    bookYourVisaService: "Viza xizmatini buyurtma qiling",
    selectTravelDate: "Sayohat sanasini tanlang",
    chooseTravelDate: "Sayohat yoki viza rasmiylashtirilish sanasini tanlang",
    yourInfoAndDocs: "Ma'lumotlaringiz va hujjatlar",
    provideDetails: "Iltimos, ma'lumotlaringizni kiriting va kerakli hujjatlarni yuklang",
    fullName: "To'liq ism",
    enterFullName: "To'liq ismingizni kiriting",
    whatsappPhone: "WhatsApp / Telefon",
    emailAddress: "Email manzil",
    uploadDocuments: "Hujjatlarni yuklash",
    passportCopy: "Pasport nusxasi",
    personalPhoto: "Shaxsiy rasm",
    clickToUpload: "Yuklash uchun bosing",
    confirmBooking: "Buyurtmani tasdiqlang",
    reviewDetails: "Iltimos, buyurtma tafsilotlarini tekshiring",
    service: "Xizmat",
    travelDate: "Sayohat sanasi",
    yourInfo: "Ma'lumotlaringiz",
    uploadedDocs: "Yuklangan hujjatlar",
    confirmationNote: "Biz 24 soat ichida WhatsApp orqali buyurtmani tasdiqlash va to'lov ma'lumotlarini taqdim etish uchun siz bilan bog'lanamiz.",
    next: "Keyingi",
    back: "Orqaga",
    confirm: "Tasdiqlash",
    submitting: "Yuborilmoqda...",
    
    // Reviews
    customerReviews: "Mijozlar sharhlari",
    leaveReview: "Sharh qoldirish",
    writeReview: "Sharhingizni yozing",
    submitReview: "Sharh yuborish",
    
    // Footer
    yourTrustedPartner: "BAAda ishonchli viza hamkoringiz",
    goodToKnow: "Foydali ma'lumot",
    bookingPolicy: "Buyurtma siyosati",
    bookingPolicyText: "24 soat ichida buyurtma tasdiqlash. To'lov qayta ishlashdan oldin talab qilinadi.",
    allRightsReserved: "Barcha huquqlar himoyalangan",
    privacyPolicy: "Maxfiylik siyosati",
    joinTelegram: "Telegram kanal",
    faq: "FAQ",
    viewSteps: "Bosqichlarni ko'rish",
    visaStatus: "Viza holati",
    myTransactions: "Mening tranzaksiyalarim",
    chatAI: "Chat AI",
    chatAiGreeting: "Salom! Sizga qanday yordam bera olaman?",
    chatApplyServices: "Xizmatlar uchun ariza berish",
    chatApplyServicesDesc: "Viza xizmatlarini ko'rish va ariza topshirish",
    chatCheckStatus: "Holatni tekshirish",
    chatCheckStatusDesc: "Viza arizangizni kuzating",
    chatCallAdmin: "Adminga qo'ng'iroq qilish",
    chatCallAdminDesc: "Adminga xabar yuborish",
    chatWriteToAdmin: "Xabaringizni yozing, biz uni adminga yuboramiz. U imkon qadar tezroq javob beradi.",
    chatMessageSentAdmin: "Xabaringiz adminga yuborildi. Iltimos, kuting, u tez orada javob beradi...",
    chatAdminReply: "Admin",
    chatWriteMessagePlaceholder: "Adminga xabar yozing...",
    chatWriteMorePlaceholder: "Yana xabar yuborish...",
    // Visa result labels (VisaChecker)
    vrLabel_VF: "Vizasiz",
    vrDesc_VF: "Viza kerak emas. Siz erkin sayohat qilishingiz mumkin.",
    vrLabel_VOA: "Kelganda viza",
    vrDesc_VOA: "Aeroportga yetib kelganingizda viza olishingiz mumkin.",
    vrLabel_ETA: "ETA",
    vrDesc_ETA: "Jo'nab ketishdan oldin elektron sayohat ruxsatnomasi talab qilinadi.",
    vrLabel_EV: "Elektron viza",
    vrDesc_EV: "Sayohatdan oldin onlayn elektron vizaga ariza topshiring.",
    vrLabel_VR: "Viza talab qilinadi",
    vrDesc_VR: "Elchixona yoki konsullikda vizaga ariza berishingiz kerak.",
    vrLabel_NA: "Kirish taqiqlangan",
    vrDesc_NA: "Bu pasport uchun kirish ruxsat etilmagan.",
    vrLabel_SAME: "Bir xil davlat",
    vrDesc_SAME: "Pasport va manzil bir xil davlat.",
    chatSelectService: "Iltimos, xizmatni tanlang:",
    chatAiRedirecting: "Sizni yo'naltiryapman...",
    chatTouristVisa: "Turistik viza",
    chatTouristVisaDesc: "Dubayga turistik viza uchun ariza topshiring",
    chatVisaChange: "Viza o'zgartirish",
    chatVisaChangeDesc: "Joriy viza holatini o'zgartiring",
    chatFreelanceVisa: "Frilanser vizasi",
    chatFreelanceVisaDesc: "Dubayda frilanser vizasini oling",
    chatTours: "Turlar",
    chatToursDesc: "Dubay turlari va tadbirlari",
    chatOpenCompany: "Kompaniya ochish",
    chatOpenCompanyDesc: "BAAdа biznesingizni boshlang",
    // Business Booking Modal
    bbmStep1Title: "Kompaniya nomi",
    bbmStep2Title: "Ismingiz",
    bbmStep3Title: "Fuqaroligi",
    bbmStep4Title: "Mobil telefon raqami",
    bbmStep5Title: "Elektron pochta manzili",
    bbmStep6Title: "Shaxsiy suratingiz",
    bbmStep7Title: "Pasport nusxasi",
    bbmStep8Title: "Tekshirish va yuborish",
    bbmStepOf: "Qadam",
    bbmCompanyName: "Kompaniya nomi",
    bbmCompanyPlaceholder: "masalan, Bright Horizons LLC",
    bbmCompanyHint: "Kompaniyangiz uchun noyob nom tanlang",
    bbmNationalityHint: "Pasportda ko'rsatilganidek",
    bbmMobileHint: "Davlat kodi bilan (masalan, +971)",
    bbmEmailHint: "Biz arizangiz tasdig'ini shu manzilga yuboramiz",
    bbmPhotoNote: "Aniq, so'nggi pasport uslubidagi suratni yuklang. Ixtiyoriy — keyinroq yuborishingiz mumkin.",
    bbmPassportNote: "Pasport ma'lumotlar sahifasining aniq skan/surati yuklang. Ixtiyoriy — keyinroq yuborishingiz mumkin.",
    bbmWantVisa: "Investor vizasini qo'shish",
    uploadPhoto: "Suratni yuklash uchun bosing",
    uploadPassport: "Pasportni yuklash uchun bosing",
    photoFormat: "JPG yoki PNG, 5MB gacha",
    passportFormat: "JPG, PNG yoki PDF, 5MB gacha",
    changePhoto: "O'zgartirish",
    changeFile: "O'zgartirish",
    businessSuccessText: "So'rovingiz qabul qilindi. Jamoamiz 24 soat ichida siz bilan bog'lanadi.",
    applicationSubmitted: "Ariza yuborildi!",
    submitApplication: "Arizani yuborish",
    fullName: "To'liq ism",
    investorVisa: "Investor vizasi",
    total: "Jami",
    yes: "Ha",
    no: "Yo'q",
    zone: "Turi",
    chatAskReference: "Iltimos, buyurtma raqamingizni kiriting:",
    chatAskReferenceForAdmin: "Admin sizga yaxshiroq yordam berishi uchun buyurtma raqamingizni kiriting:",
    chatAdminMessageReady: "Rahmat, {name}! Endi xabaringizni yozing, biz uni adminga yuboramiz.",
    chatAskPassport: "Buyurtma topildi! Tasdiqlash uchun pasport raqamingizni kiriting:",
    chatBookingNotFound: "Buyurtma topilmadi. Raqamni tekshirib, qaytadan urinib ko'ring.",
    chatPassportMismatch: "Pasport raqami mos kelmadi. Qaytadan urinib ko'ring.",
    chatWelcome: "Xush kelibsiz",
    chatCurrentStatus: "Joriy holat",
    chatAgent: "Agent",
    chatWhoIsMyAgent: "Mening agentim kim?",
    chatYourAgent: "Sizning agentingiz",
    chatAskAgentNumber: "Agent raqamini so'rash",
    chatAgentNumber: "Agent raqami",
    chatAskQuestion: "Vizangiz haqida so'rang...",
    chatSendToAdmin: "Adminga yuborish",
    chatSentToAdmin: "Xabaringiz adminga yuborildi. Tez orada siz bilan bog'lanishadi.",
    chatSentLabel: "Adminga yuborildi",
    chatOfferAdmin: "Xabaringizni adminga yuborishimni xohlaysizmi? Nimaga ehtiyojingiz borligini aniq yozing, men yuboraman.",
    chatBackToMenu: "Menyuga qaytish",
    chatRefPlaceholder: "masalan RAMIZ20260001",
    chatPassportPlaceholder: "masalan FA3204764",
    chatError: "Xatolik yuz berdi. Qaytadan urinib ko'ring.",
    chatOnline: "Onlayn",
    chatApprovedDocs: "Tasdiqlangan hujjatlar",
    chatVoiceListen: "Holatni tinglash",
    chatVoiceStop: "To'xtatish",
    startBusiness: "Biznes ochish",
    home: "Bosh sahifa",
    tours: "Turlar",
    about: "Biz haqimizda",

    // Tours Page
    tourHeroBadge: "Dubay turlari va tadbirlari",
    tourHeroTitle: "Dubayning eng yaxshilarini kashf eting",
    tourHeroDesc: "Cho'l safarilari, Burj Xalifa chiptalari, vodiy mototsikllari, shahar sayohatlari, kechki kruizlar va boshqalar — Registan Tourism'dan eng yaxshi narxlarda.",
    tourBookViaWhatsApp: "WhatsApp orqali band qilish",
    tourAll: "Barchasi",
    tourLoading: "Turlar yuklanmoqda...",
    tourNoTours: "Turlar topilmadi",
    tourCheckBack: "Tez orada Dubayga qiziqarli turlar paydo bo'ladi!",
    tourBookNow: "Band qilish",
    tourWhyTitle: "Nima uchun Registan Tourism bilan Dubay turlarini band qilish kerak?",
    tourBestPrice: "Eng yaxshi narx kafolati",
    tourBestPriceDesc: "Biz barcha Dubay turlari va tadbirlari uchun eng raqobatbardosh narxlarni taklif etamiz. Yashirin to'lovlarsiz.",
    tourExpertGuides: "Tajribali mahalliy gidlar",
    tourExpertGuidesDesc: "Barcha turlarni Dubayni ichidan biladigan sertifikatlangan mahalliy gidlar olib boradi.",
    tourFlexibleBooking: "Moslashuvchan band qilish",
    tourFlexibleBookingDesc: "24 soat oldin bepul bekor qilish. Hozir band qiling, keyinroq to'lang.",
    tourWhatsAppSupport: "24/7 WhatsApp qo'llab-quvvatlash",
    tourWhatsAppSupportDesc: "WhatsApp orqali tezkor band qilish va qo'llab-quvvatlash. Bir necha daqiqada javob beramiz.",
    tourReadyTitle: "Dubay sarguzashtlariga tayyormisiz?",
    tourReadyDesc: "Tezkor band qilish, individual turlar va guruh chegirmalari uchun WhatsApp orqali biz bilan bog'laning.",
    tourBookTour: "Turni band qilish",
    tourGuestName: "Mehmon ismi",
    tourBookingDate: "Band qilish sanasi",
    tourNumberOfPeople: "Odamlar soni",
    tourMobileNumber: "Telefon raqami",
    tourEmailAddress: "Elektron pochta",
    tourCurrentLocation: "Joriy joylashuv",
    tourFullName: "To'liq ism",
    tourHotelOrArea: "Mehmonxona nomi yoki hudud",
    tourPricePerPerson: "Bir kishi uchun narx",
    tourPeople: "Kishi",
    tourTotal: "Jami",
    tourCancel: "Bekor qilish",
    tourSubmitBooking: "Buyurtmani yuborish",
    tourSubmitting: "Yuborilmoqda...",
    tourBookingSubmitted: "Buyurtma yuborildi!",
    tourBookingThankYou: "Sizning buyurtmangiz qabul qilindi. Jamoamiz tez orada siz bilan bog'lanadi.",
    tourDone: "Tayyor",

    // FAQ Page
    backToHome: "Bosh sahifa",
    faqTitle: "Ko'p so'raladigan savollar",
    faqSubtitle: "Viza xizmatlarimiz, qayta ishlash muddatlari va boshqalar haqida tez-tez beriladigan savollarga javob toping.",
    stillHaveQuestions: "Savollaringiz bormi?",
    contactUsAnytime: "Jamoamiz har qanday so'rovlar uchun 24/7 yordam berishga tayyor.",
    
    // Booking Card
    open: "Ochiq",
    closesAt: "Yopiladi",
    contactUs: "Bog'lanish",
    whatsapp: "WhatsApp",
    callNow: "Qo'ng'iroq",
    
    // Auth
    welcomeBack: "Xush kelibsiz",
    signInAccess: "Buyurtmalaringizga kirish uchun tizimga kiring",
    createAccount: "Akkaunt yaratish",
    joinUs: "Viza xizmatlari buyurtmasi uchun ro'yxatdan o'ting",
    password: "Parol",
    enterPassword: "Parolni kiriting",
    forgotPassword: "Parolni unutdingizmi?",
    signIn: "Kirish",
    dontHaveAccount: "Akkauntingiz yo'qmi?",
    alreadyHaveAccount: "Akkauntingiz bormi?",
    
    // Dashboard
    myBookings: "Mening buyurtmalarim",
    myReviews: "Mening sharhlarim",
    profile: "Profil",
    noBookings: "Hali buyurtmalar yo'q",
    home: "Bosh sahifa",
    transactions: "Tranzaksiyalar",
    approved: "Tasdiqlangan",
    
    // Common
    loading: "Yuklanmoqda...",
    error: "Xato",
    success: "Muvaffaqiyat",
    cancel: "Bekor qilish",
    save: "Saqlash",
    delete: "O'chirish",
    edit: "Tahrirlash",
    view: "Ko'rish",
    download: "Yuklab olish",
    remove: "Olib tashlash",
    // Booking form
    firstName: "Ism",
    lastName: "Familiya",
    dateOfPlanning: "Rejalashtirish sanasi",
    nationality: "Millat",
    selectNationality: "Millatni tanlang",
    selectVisaDuration: "Viza muddatini tanlang",
    chooseVisaDuration: "O'zingizga mos viza muddatini tanlang",
    chooseTransport: "Viza almashtirishni qanday qilmoqchisiz?",
    selectTransportMethod: "Iltimos, birini tanlang",
    readingPassport: "Pasport ma'lumotlari o'qilmoqda...",
    passportDataExtracted: "Pasport ma'lumotlari aniqlandi — noto'g'ri bo'lsa tahrirlashingiz mumkin",
    dateOfBirth: "Tug'ilgan sana",
    passportNumber: "Pasport raqami",
    // Visa Checker
    visaChecker: "Viza tekshirish",
    visaCheckerDesc: "Dunyo bo'ylab istalgan mamlakat uchun viza talablarini tekshiring",
    yourCitizenship: "Sizning fuqaroligingiz",
    destination: "Manzil",
    selectCountry: "Mamlakatni tanlang...",
    checkVisa: "Viza talablarini tekshirish",
    checking: "Tekshirilmoqda...",
    sameCountryError: "Fuqarolik va manzil bir xil bo'lishi mumkin emas",
    visaCheckError: "Viza talablarini tekshirib bo'lmadi. Qaytadan urinib ko'ring.",
    stayDuration: "Yashash muddati",
    applyNow: "Ariza berish",
    applyForVisa: "Viza uchun ariza",
    applicationSent: "Ariza yuborildi!",
    applicationSentDesc: "Biz sizning viza arizangiz bo'yicha tez orada bog'lanamiz.",
    submitApplication: "Arizani yuborish",
    areYouUAEResident: "Siz BAA rezidentimisiz?",
    enterEmail: "Email manzilingizni kiriting",
    submitting: "Yuborilmoqda...",
    done: "Tayyor",
    yes: "Ha",
    no: "Yo'q",
    // SEO Content
    seoDubaiTitle: "Dubay vizasi xizmatlari — BAA turistik vizasini onlayn rasmiylashtiring",
    seoDubaiP1: "Registan Tourism minglab sayohatchilarga Dubay vizasini tez va arzon narxda rasmiylashtirish uchun yordam beradigan ishonchli viza xizmati. Sizga 14 kunlik qisqa muddatli turistik viza, standart 30 kunlik BAA vizasi yoki uzaytirilgan 60 kunlik Dubay vizasi kerak bo'ladimi — biz hujjatlarni tekshirishdan tortib arizani topshirishgacha butun jarayonni o'z zimmamizga olamiz. Jamoamiz 3-5 ish kuni ichida tezkor ishlashni ta'minlaydi.",
    seoDubaiP2: "Dubay turistik vizasini onlayn rasmiylashtirish hech qachon bunday oson bo'lmagan. Pasportingizni yuklang va bizning aqlli OCR tizimimiz avtomatik ravishda fuqarolik, tug'ilgan sana, pasport raqami, berilgan sana va amal qilish muddatini o'qiydi. Biz pasportingiz kamida olti oy davomida amal qilishini tekshiramiz, bu BAA immigratsiya talablariga to'liq muvofiqlikni ta'minlaydi. Xizmatimiz barcha fuqaroliklar uchun ishlaydi va biz viza holatini real vaqtda kuzatishni taqdim etamiz.",
    seoDubaiP3: "Dubay dunyodagi eng ko'p tashrif buyuriladigan shaharlardan biri bo'lib, har yili millionlab turistlarni biznes, dam olish va tranzit uchun jalb qiladi. Registan Tourism bilan siz raqobatbardosh narxlarga ega bo'lasiz: 14 kunlik viza uchun 350 AED, 30 kunlik viza uchun 500 AED va 60 kunlik viza uchun 800 AED. Mijozlarga xizmat ko'rsatish jamoamiz WhatsApp va onlayn chat orqali BAA viza talablari, kirish qoidalari va hujjatlar haqidagi barcha savollaringizga javob berish uchun tayyor. Bugun Dubay vizangizni buyurtma qiling.",
    seoVisaChangeTitle: "BAAdagi vizarani xizmati — Mashina, avtobus yoki samolyotda",
    seoVisaChangeP1: "BAAdagi viza holatini yangilash yoki o'zgartirish kerakmi? Registan Tourism yangi viza olish uchun mamlakatdan chiqib, qayta kirish imkonini beruvchi to'liq vizaran xizmatini taklif etadi. Biz uchta qulay variantni taqdim etamiz: Omonga mashinada vizaran, avtobusda vizaran yoki samolyotda vizaran. Har bir usul tajribali jamoamiz tomonidan to'liq boshqariladi.",
    seoVisaChangeP2: "Mashinada vizaran eng mashhur variant bo'lib, Omon chegarasigacha va qaytib bir necha soat ichida qulay sayohat qilasiz. Byudjetga mos variantni afzal ko'rganlar uchun avtobus xizmati professional muvofiqlashtirish bilan arzon vizaranni taklif etadi. Tezroq variant kerak bo'lsa, samolyotda vizaran eng tez usulni ta'minlaydi. Barcha variantlar 30 va 60 kunlik viza yangilashni o'z ichiga oladi, narxlar avtobusda 30 kunlik vizaran uchun 750 AED dan boshlanadi.",
    seoVisaChangeP3: "BAAdagi vizaran jarayoni viza turini o'zgartirish, yashashni uzaytirish yoki vizani yangilash kerak bo'lgan rezidentlar va mehmonlar uchun zarur. Registan Tourism bu jarayonni shaffof narxlar, real vaqtda yangilanishlar va eshikdan eshikgacha muvofiqlashtirish bilan soddalashtiradi. Bizning bronlash tizimimiz viza muddati va sayohat usuli asosida umumiy narxni bir zumda hisoblab beradi. Dubay, Abu-Dabi yoki boshqa amirlikdagi tourist, frilanser yoki ishbilarmon bo'lsangiz — biz ishonchli vizaran xizmatlarini taqdim etamiz. Bugun biz bilan bog'laning.",
    enterNamePassport: "Pasportingizdagi ismingizni kiriting",
    selectTravelDate: "Rejalashtirilgan sayohat sanasini tanlang",
    days: "Kun",
    // Dubai Visa Steps
    dubaiStep1Title: "Qanday ariza berish mumkin?",
    dubaiStep1Desc: "Bu viza tasdiqlash uchun siz BAA dan tashqarida bo'lganingizda rasmiylashtirilishi kerak.",
    dubaiStep2Title: "Vizaning amal qilish muddati qancha?",
    dubaiStep2Desc: "Vizangiz tasdiqlangandan so'ng — 30 yoki 60 kunlik bo'lsin — viza muddati tugashidan oldin istalgan vaqtda BAAga kirishingiz mumkin. BAAga kirgandan so'ng viza muddati kirish sanasidan boshlab hisoblanadi: 30 kunlik viza 29 kun yashashga, 60 kunlik viza esa 58 kun yashashga ruxsat beradi.",
    dubaiStep3Title: "Vizani uzaytirish mumkinmi?",
    dubaiStep3Desc: "Ha, vizangizni mamlakatni tark etmasdan BAA ichida uzaytirishingiz mumkin. 30 kunlik vizani faqat 2 marta uzaytirish mumkin.",
    // Family Visa Steps
    familyVisaName: "Oilaviy viza",
    familyVStep1Title: "Oila a'zosini tanlang",
    familyVStep1Desc: "Oilaviy vizani kimga rasmiylashtirmoqchisiz: er, xotin, o'g'il, qiz yoki ona.",
    familyVStep2Title: "Hujjatlarni yuklang",
    familyVStep2Desc: "Viza uchun ariza berilayotgan oila a'zosining pasport nusxasi va shaxsiy rasmini yuklang.",
    familyVStep3Title: "Emirates ID ko'rinishi",
    familyVStep3Desc: "Tizimimiz pasport ma'lumotlari asosida Emirates ID ko'rinishini yaratadi. Davom etishdan oldin barcha ma'lumotlarni tekshiring.",
    familyVStep4Title: "Aloqa ma'lumotlari",
    familyVStep4Desc: "Ariza holati haqida xabar berish uchun WhatsApp raqamingiz va elektron pochtangizni kiriting.",
    familyVStep5Title: "Tekshirish va tasdiqlash",
    familyVStep5Desc: "Oilaviy viza arizangizning barcha ma'lumotlarini tekshiring va yuborishni tasdiqlang. Holatni kuzatish uchun raqam olasiz.",
    
    // Freelance Visa Steps
    freelanceVStep1Title: "Ariza topshirish",
    freelanceVStep1Desc: "Shaxsiy ma'lumotlaringizni to'ldiring, pasport nusxasi va rasmingizni yuklang. Jamoamiz frilanser vizangizni rasmiylashtiradi.",
    freelanceVStep2Title: "Viza tasdiqlandi",
    freelanceVStep2Desc: "Frilanser viza arizangiz ko'rib chiqildi va tasdiqlandi. Viza tasdiqlash hujjati bilan tasdiqnoma olasiz.",
    freelanceVStep3Title: "Opsiya o'zgartirish",
    freelanceVStep3Desc: "Viza holatingiz tizimda yangilandi. Frilanser ruxsatnomangiz uchun zarur opsiya o'zgarishlari amalga oshirildi.",
    freelanceVStep4Title: "Tibbiy tekshiruv",
    freelanceVStep4Desc: "Tasdiqlangan sog'liqni saqlash markazida majburiy tibbiy tekshiruvdan o'ting. Natijalar immigratsiya xizmatiga yuboriladi.",
    freelanceVStep5Title: "Rezidentlik vizasi",
    freelanceVStep5Desc: "BAA rezidentlik vizangiz berildi. Bu sizga BAAdA frilanser sifatida qonuniy yashash va ishlash imkonini beradi.",
    freelanceVStep6Title: "Emirates ID",
    freelanceVStep6Desc: "Emirates ID kartangiz tayyorlandi va berildi. Bu BAAda barcha operatsiyalar uchun rasmiy shaxsni tasdiqlovchi hujjatingiz.",

    // Modal Common
    howItWorks: "Qanday ishlaydi",
    gotIt: "Tushunarli",

    // Dashboard Page
    loadingDashboard: "Kabinet yuklanmoqda...",
    noBookingsYet: "Buyurtmalar yo'q",
    noBookingsDesc: "Sizda hali buyurtmalar yo'q. Viza xizmatlarimizni ko'ring!",
    browseServices: "Xizmatlarni ko'rish",
    total: "jami",
    nameLabel: "Ism",
    nationalityLabel: "Millati",
    passportNumberLabel: "Pasport №",
    travelDateLabel: "Sayohat sanasi",
    priceLabel: "Narxi",
    bookedLabel: "Buyurtma qilingan",
    yourDocuments: "Sizning hujjatlaringiz",
    passport: "Pasport",
    photo: "Rasm",
    documentFromRegistan: "Registon Turizmdan hujjat",
    downloadDocument: "Hujjatni yuklab olish",
    weWillContact: "Biz siz bilan bog'lanamiz",
    contactViaWhatsApp: "WhatsApp orqali bog'lanish",
    deleteBookingTitle: "Buyurtmani o'chirishmi?",
    deleteWarning: "Ogohlantirish: Bu amalni qaytarib bo'lmaydi!",
    deleteInfo: "Siz buyurtmani o'chirmoqchisiz:",
    deletePermanent: "Bu buyurtma va barcha hujjatlar butunlay o'chiriladi.",
    yesDeleteForever: "Ha, o'chirish",
    deleting: "O'chirilmoqda...",
    noReviewsYet: "Sharhlar yo'q",
    noReviewsDesc: "Siz hali sharh qoldirmadingiz. Tajribangizni ulashing!",
    rating: "Reyting",
    review: "Sharh",
    saveChanges: "O'zgarishlarni saqlash",
    editPhoto: "Rasmni tahrirlash",
    updateProfilePhoto: "Profil rasmini yangilash",
    uploadPhotoOrAvatar: "Rasm yuklang yoki avatar tanlang",
    uploadPhoto: "Rasm yuklash",
    chooseAvatar: "Avatar tanlash",
    removePhoto: "Rasmni o'chirish",
    uploading: "Yuklanmoqda...",
    documentRequired: "Hujjat kerak",
    documentReuploadRequired: "Hujjatni qayta yuklash kerak",
    required: "Kerak",
    reason: "Sabab",
    reupload: "Qayta yuklash",
    submitDocument: "Hujjatni yuborish",
    uploadingDocument: "Hujjat yuklanmoqda...",
    selected: "Tanlangan",
    signingIn: "Kirish...",
    creatingAccount: "Akkaunt yaratilmoqda...",
    mobileNumber: "Telefon raqami",
    optional: "Ixtiyoriy",
    minChars: "Kamida 6 belgi",
    joinRegistan: "Registon Turizmga qo'shiling",
    date: "Sana",
    details: "Tafsilotlar",
    
    // Forgot Password
    forgotPassword: "Parolni unutdingizmi?",
    forgotPasswordTitle: "Parolni unutdingizmi?",
    forgotPasswordDesc: "Emailingizni kiriting, biz parolni tiklash havolasini yuboramiz.",
    sendResetLink: "Havola yuborish",
    sending: "Yuborilmoqda...",
    checkYourEmail: "Emailingizni tekshiring",
    resetEmailSent: "Parolni tiklash havolasini yubordik. Kiruvchi xatlarni tekshiring.",
    backToLogin: "Kirishga qaytish",
    rememberPassword: "Parolingizni eslaydingizmi?",
    forgotPasswordError: "Email yuborib bo'lmadi. Qayta urinib ko'ring.",
    
    // Reset Password Page
    resetPasswordTitle: "Parolni tiklash",
    resetPasswordDesc: "Yangi parolingizni quyida kiriting.",
    verifyingToken: "Havola tekshirilmoqda...",
    invalidToken: "Yaroqsiz havola",
    invalidTokenDesc: "Bu havola yaroqsiz yoki muddati o'tgan. Yangi havola so'rang.",
    requestNewLink: "Yangi havola so'rash",
    passwordResetSuccess: "Parol muvaffaqiyatli tiklandi!",
    passwordResetSuccessDesc: "Parolingiz yangilandi. Kirishga yo'naltirilmoqda...",
    goToLogin: "Kirishga o'tish",
    newPassword: "Yangi parol",
    confirmPassword: "Parolni tasdiqlang",
    enterNewPassword: "Yangi parolni kiriting",
    confirmNewPassword: "Yangi parolni tasdiqlang",
    resetPassword: "Parolni tiklash",
    resetting: "Tiklanmoqda...",
    passwordMinLength: "Parol kamida 6 belgidan iborat bo'lishi kerak",
    passwordsNoMatch: "Parollar mos kelmaydi",
    resetPasswordError: "Parolni tiklab bo'lmadi. Qayta urinib ko'ring.",
    
    jpgPngPdf: "JPG, PNG yoki PDF (maks. 5MB)",
    jpgPng: "JPG yoki PNG (maks. 5MB)",
    clickToUploadPassport: "Pasportni yuklash uchun bosing",
    clickToUploadPhoto: "Rasmni yuklash uchun bosing",
    usingAccountEmail: "Akkaunt emailingiz ishlatilmoqda",
    star: "yulduz",
    stars: "yulduz",
    
    // Step-by-Step Booking
    enterFullNamePassport: "Pasportda ko'rsatilganidek to'liq ismingizni kiriting",
    enterPhoneContact: "Siz bilan bog'lanish uchun WhatsApp raqamingizni kiriting",
    enterEmailConfirmation: "Bronlashni tasdiqlash uchun emailingizni kiriting",
    uploadPassport: "Pasportni yuklash",
    uploadPassportInstruction: "Pasportning aniq rasmini yuklang. Biz ma'lumotlaringizni avtomatik chiqaramiz.",
    uploadPhotoInstruction: "Viza arizasi uchun aniq shaxsiy rasmingizni yuklang",
    extractingData: "Pasport ma'lumotlari chiqarilmoqda...",
    extractedInfo: "Chiqarilgan ma'lumotlar",
    surname: "Familiya",
    givenNames: "Ism va sharif",
    dateOfBirth: "Tug'ilgan sana",
    nationality: "Fuqarolik",
    passportNumber: "Pasport raqami",
    passportExpiry: "Amal qilish muddati",
    reviewConfirm: "Ko'rib chiqish va tasdiqlash",
    reviewInstruction: "Ma'lumotlaringizni tekshiring. O'zgartirish uchun tahrirlash tugmasini bosing.",
    contactInfo: "Aloqa ma'lumotlari",
    passportInfo: "Pasport ma'lumotlari",
    phone: "Telefon",
    email: "Email",
    expiryDate: "Amal qilish muddati",
    issueDate: "Berilgan sana",
    notPassportError: "Bu pasportga o'xshamaydi. Iltimos, pasportingizni yuklang.",
    passportExpiringSoon: "Pasportingiz muddati 6 oydan kam qolgan. Ariza berishdan oldin pasportni yangilang.",
    bookingSuccess: "Bronlash muvaffaqiyatli!",
    bookingFailed: "Bronlash xatosi. Qayta urinib ko'ring.",
    pleaseEnterName: "Iltimos, to'liq ismingizni kiriting",
    pleaseEnterPhone: "Iltimos, telefon raqamingizni kiriting",
    pleaseEnterEmail: "Iltimos, emailingizni kiriting",
    pleaseUploadPassport: "Iltimos, pasportingizni yuklang",
    pleaseUploadPhoto: "Iltimos, rasmingizni yuklang",
    uploadPassportSimple: "Pasportingizning aniq rasmini yuklang",
    reviewInstruction: "Iltimos, tasdiqlashdan oldin ma'lumotlaringizni tekshiring.",
    // Debit Card
    debitCardQuestion: "Sizga debet karta kerakmi?",
    debitCardDescription: "Frilanser vizangiz bilan birga BAA bank debet kartasini oling, qo'shimcha 500 AED",
    debitCard: "Debet karta",
    yes: "Ha",
    no: "Yo'q",
    skipDebitCard: "O'tkazib yuborish",
    pleaseSelectDebitCard: "Iltimos, Ha yoki Yo'q tanlang",
    // PDF Number Remover
    pdfTitle: "Fayllardan +971 raqamlarini olib tashlash",
    pdfDescription: "PDF, JPG yoki PNG faylni yuklang. Tizim avtomatik ravishda barcha BAA mobil raqamlarini (+971XXXXXXXXX) topadi va olib tashlab, tozalangan faylni qaytaradi.",
    pdfDropzone: "Faylingizni bu yerga tashlang yoki tanlash uchun bosing",
    pdfDropzoneHint: "PDF, JPG, PNG qo'llab-quvvatlanadi (maks. 20MB)",
    pdfYourNumber: "Sizning raqamingiz (ixtiyoriy)",
    pdfYourNumberHint: "O'chirilganlar o'rniga sizning raqamingizni kiriting",
    pdfRemoveBtn: "Raqamlarni olib tashlash",
    pdfProcessing: "Qayta ishlanmoqda...",
    pdfComplete: "Qayta ishlash yakunlandi",
    pdfFoundAndReplaced: "Topildi",
    pdfNumbers: "raqam(lar)",
    pdfFoundAndRemoved: "Topildi va olib tashlandi",
    pdfNoNumbers: "Faylingizda +971 telefon raqamlari topilmadi.",
    pdfNumbersRemoved: "O'chirilgan raqamlar",
    pdfDownload: "Tozalangan faylni yuklab olish",
    pdfAnother: "Boshqa faylni qayta ishlash",
    pdfSecure: "Fayllaringiz xavfsiz qayta ishlanadi va yuklab olingandan keyin o'chiriladi",
    pdfSupports: "PDF hujjatlar, JPG va PNG rasmlar qo'llab-quvvatlanadi",
    pdfOnlyFileTypes: "Iltimos, faqat PDF, JPG yoki PNG fayl yuklang.",
    pdfFileTooLarge: "Fayl hajmi 20MB dan oshmasligi kerak.",
    pdfProcessingFailed: "Faylni qayta ishlashda xatolik. Qaytadan urinib ko'ring.",
    // 404 Page
    notFoundTitle: "Siz xaritadan chiqib ketdingiz",
    notFoundText: "Siz qidirayotgan sahifa cho'lda adashib qoldi. Sizni yo'lga qaytaramiz.",
    notFoundBtn: "Meni bosh sahifaga qaytar",
    notFoundTryLabel: "Yoki sinab ko'ring:",
    goneTitle: "Bu sahifa o'chirilgan",
    goneText: "Bu sahifa endi mavjud emas va butunlay o'chirilgan.",
    // About Page
    aboutMetaTitle: "Registan Tourism haqida — Dubay vizasi xizmatlari va BAA sayohat agentligi",
    aboutMetaDesc: "Registan Tourism — Dubay vizasi xizmatlarining yetakchi provayderi: BAA turistik vizalari, viza almashtirish, oilaviy viza, frilanser viza va Dubayda biznes ochish.",
    aboutBadge: "Dubay, BAA da joylashgan",
    aboutHeroTitle: "Registan Tourism — Sizning ishonchli Dubay viza xizmati va BAA sayohat agentligingiz",
    aboutHeroDesc: "Biz minglab sayohatchilarga Dubay vizasini onlayn ravishda olishda, BAA vizasini almashtirishda va Emiratlarda biznes ochishda yordam beramiz. Tez, ishonchli va arzon viza xizmatlari 24/7 qo'llab-quvvatlash bilan.",
    aboutApplyBtn: "Dubay vizasiga ariza berish",
    aboutWhatsappBtn: "WhatsApp orqali yozish",
    aboutStatCountries: "Mamlakat xizmat ko'rsatilgan",
    aboutStatSupport: "Mijozlarni qo'llab-quvvatlash",
    aboutStatApproval: "Tasdiqlash darajasi",
    aboutWhoTitle: "BAA ga yo'lingiz — ishonchga qurilgan, tajribaga asoslangan",
    aboutWhoP1: "Registan Tourism — bu 15 dan ortiq mamlakatdan kelgan sayohatchilarga BAA turistik vizalari, tashrif vizalari va tranzit vizalarini tez va samarali olishda yordam beruvchi professional Dubay viza agentligi. Tajribali immigratsiya maslahatchilari jamoamiz har bir arizani eng yuqori aniqlik bilan ko'rib chiqadi.",
    aboutWhoP2: "Sizga 14 kunlik Dubay vizasi, 30 kunlik BAA turistik vizasi yoki 60 kunlik uzoq muddatli viza kerak bo'ladimi — biz butun jarayonni hujjatlarni tekshirishdan viza muhrini bosishgacha olib boramiz. Bizning onlayn bron qilish tizimimiz pasport ma'lumotlarini avtomatik o'qish uchun OCR texnologiyasidan foydalanadi.",
    aboutWhoP3: "Turistik vizalardan tashqari, biz BAA da viza almashtirish xizmatlariga ixtisoslashganmiz — vizaran deb ham ataladi. Omonga mashinada, avtobusda yoki samolyotda viza almashtirish — viza holatini yangilashning qulay usullari.",
    aboutWhoP4: "Shuningdek, biz Dubayda oilaviy viza homiyligini, BAA erkin zonalarida frilanser viza va biznes litsenziya rasmiylashtirishni, hamda BAA immigratsiyasi bo'yicha ekspert maslahatlari taklif etamiz. Bizning maqsadimiz — viza xizmatlarini hamma uchun qulay va shaffof qilish.",
    aboutServicesTitle: "Dubay vizasi va BAA sayohat xizmatlarimiz",
    aboutServicesSubtitle: "Turistlar, rezidentlar va biznes uchun viza va immigratsiya yechimlari",
    aboutSvcVisaTitle: "Dubay turistik vizasi",
    aboutSvcVisaDesc: "14, 30 va 60 kunlik BAA turistik vizalari 3-5 ish kunida tez qayta ishlash bilan.",
    aboutSvcChangeTitle: "Viza almashtirish xizmati",
    aboutSvcChangeDesc: "Mashina, avtobus yoki samolyotda qulay viza almashtirish, chegara o'tish koordinatsiyasi bilan.",
    aboutSvcFamilyTitle: "BAA oilaviy vizasi",
    aboutSvcFamilyDesc: "Er, xotin, o'g'il, qiz yoki onangizni BAA oilaviy rezidentlik vizasi uchun homiylik qilish.",
    aboutSvcBusinessTitle: "Dubayda biznes ochish",
    aboutSvcBusinessDesc: "Dubay erkin zonalarida frilanser viza va biznes litsenziya rasmiylashtirishning to'liq xizmati.",
    aboutSvcConsultTitle: "Viza maslahati",
    aboutSvcConsultDesc: "BAA immigratsiyasi, viza turlari, talablar va hujjatlar bo'yicha ekspert yo'riqnomasi.",
    aboutSvcPremiumTitle: "Premium xizmat",
    aboutSvcPremiumDesc: "Ustuvor qayta ishlash, VIP qo'llab-quvvatlash va shoshilinch arizalar uchun shaxsiy menejer.",
    aboutWhyTitle: "Nima uchun Dubay vizasi uchun Registan Tourism ni tanlaysiz?",
    aboutWhySubtitle: "Butun dunyo bo'ylab yuzlab sayohatchilar tomonidan ishonchli",
    aboutWhyFastTitle: "Tez qayta ishlash",
    aboutWhyFastDesc: "Dubay vizangizni 3-5 ish kunida oling — bizning soddolashtirilgan tizimimiz orqali.",
    aboutWhyTrustedTitle: "Ishonchli va litsenziyalangan",
    aboutWhyTrustedDesc: "BAA da ro'yxatdan o'tgan vakolatli viza xizmati provayderi, ko'p yillik tajribaga ega.",
    aboutWhyApprovalTitle: "Yuqori tasdiqlash darajasi",
    aboutWhyApprovalDesc: "Hujjatlarni sinchkov tekshirish va talablarga rioya qilish tufayli 99% viza tasdiqlash.",
    aboutWhyReviewsTitle: "5 yulduzli sharhlar",
    aboutWhyReviewsDesc: "Butun dunyodan yuzlab mamnun mijozlar BAA vizasi uchun Registan Tourism ga ishonishadi.",
    aboutWhyWhatsappTitle: "24/7 WhatsApp qo'llab-quvvatlash",
    aboutWhyWhatsappDesc: "Har qanday vaqtda WhatsApp, chat yoki email orqali ko'p tilli qo'llab-quvvatlash jamoamizdan yordam oling.",
    aboutWhyLocalTitle: "Dubayda joylashgan",
    aboutWhyLocalDesc: "BAA viza qoidalari va immigratsiya siyosati haqida chuqur bilimga ega Dubaydagi ofis.",
    aboutCtaTitle: "Dubay vizasiga ariza berishga tayyormisiz?",
    aboutCtaDesc: "BAA vizasi rasmiylashtirishni bugun boshlang. Tez qayta ishlash, arzon narxlar va Dubaydagi jamoamizdan shaxsiy qo'llab-quvvatlash.",
    aboutCtaBtn: "Ariza berish",
    // Chat
    startChat: "Chatni boshlash",
    registanSupport: "Registan qo'llab-quvvatlash",
    chatWelcome: "Xush kelibsiz!",
    chatWelcomeDesc: "Suhbatni boshlash yoki avvalgi suhbatni davom ettirish uchun ma'lumotlaringizni kiriting.",
    yourName: "Ismingiz",
    enterYourName: "Ismingizni kiriting",
    phoneNumber: "Telefon raqami",
    startChatBtn: "Chatni boshlash",
    loadingChat: "Yuklanmoqda...",
    loadingMessages: "Xabarlar yuklanmoqda...",
    noMessagesYet: "Hozircha xabarlar yo'q. Suhbatni boshlang!",
    typeMessage: "Xabar yozing...",
    sending: "Yuborilmoqda...",
    // Admin
    addService: "Xizmat qo'shish",
    editService: "Xizmatni tahrirlash",
    deleteBtn: "O'chirish",
    editBtn: "Tahrirlash",
    stepsBtn: "Bosqichlar",
    nSteps: "Bosqichlar",
    serviceName: "Xizmat nomi",
    price: "Narxi",
    duration: "Muddat",
    subtitle: "Sarlavha",
    category: "Kategoriya",
    description: "Tavsif",
    serviceImage: "Xizmat rasmi",
    saveChanges: "Saqlash",
    cancel: "Bekor qilish",
    selectCategory: "Kategoriyani tanlang",
    moveUp: "Yuqoriga",
    moveDown: "Pastga",
    
    // Family Visa
    familyVisa: "Oilaviy Viza",
    familyVisaName: "Oilaviy Viza",
    descFamilyVisa: "Oilangizni BAAga professional oilaviy viza xizmati bilan olib keling. Biz barcha hujjatlar, homiylik talablari bilan shug'ullanamiz va yaqinlaringiz uchun muammosiz jarayonni ta'minlaymiz.",
    whoApplyVisaFor: "Kim uchun viza olmoqchisiz?",
    selectFamilyMember: "Oila a'zosini tanlang",
    husband: "Er",
    son: "O'g'il",
    daughter: "Qiz",
    mother: "Ona",
    uploadPassportPhoto: "Pasport va rasmni yuklang",
    uploadPassportPhotoOf: "Iltimos, pasport va shaxsiy rasmni yuklang",
    emiratesIdPreview: "Emirates ID ko'rinishi",
    reviewPassportInfo: "Pasportdan olingan ma'lumotlarni tekshiring",
    firstNameLabel: "Ism",
    lastNameLabel: "Familiya",
    dateOfBirthLabel: "Tug'ilgan sana",
    nationalityLabel: "Fuqarolik",
    unitedArabEmirates: "BIRLASHGAN ARAB AMIRLIKLARI",
    confirmApplication: "Arizani tasdiqlash",
    reviewSubmitFamilyVisa: "Iltimos, oilaviy viza arizasini tekshiring va yuboring",
    applyingFor: "Kimga",
    name: "Ism",
    bySubmittingAgree: "Yuborish orqali siz shartlarimizga rozilik bildirasiz. Biz 24 soat ichida siz bilan bog'lanamiz.",
    dataExtracted: "Ma'lumotlar olingan",
    goBackUploadClear: "Iltimos, orqaga qayting va ma'lumotlarni olish uchun aniq pasport rasmini yuklang",
    clickUploadPassport: "Pasportni yuklash uchun bosing",
    clickUploadPhoto: "Rasmni yuklash uchun bosing",
    readingPassportData: "Pasport ma'lumotlari o'qilmoqda...",
    contactInfo: "Aloqa ma'lumotlari",
    enterContactDetails: "Iltimos, siz bilan bog'lanishimiz uchun aloqa ma'lumotlarini kiriting",
    whatsappNumber: "WhatsApp raqami",
    emailAddress: "Elektron pochta",
    weWillContactYou: "Arizangiz bo'yicha yangilanishlar uchun WhatsApp orqali bog'lanamiz",
    telegram: "Telegram",
    telegramOptional: "Telegram (ixtiyoriy)",
    telegramOptionalHint: "Tasdiqlangandan so'ng vizа hujjatlaringizni to'g'ridan-to'g'ri Telegramga yuboramiz.",
    phoneOrTelegram: "Telefon yoki Telegram raqami",
    phoneOrTelegramHint: "Telefon raqamingiz yoki Telegram raqamingizni kiriting — tasdiqlangandan so'ng hujjatlarni Telegramga yuboramiz.",
    phoneOrTelegramNote: "WhatsApp raqami yoki Telegram @username — har ikkalasi ham ishlaydi.",
    contactNumbers: "Aloqa raqamlari",
    phoneNumber: "Telefon raqami",
    phoneAndTelegramHint: "Tasdiqlangan hujjatlarni yuborishimiz uchun telefon raqamingiz va Telegram/WhatsApp raqamini kiriting.",
    sameNumberForTelegram: "Telegram / WhatsApp uchun bir xil raqam ishlataman",
    telegramOrWhatsapp: "Telegram yoki WhatsApp raqami",
    telegramShareDocsHint: "Tasdiqlangan hujjatlaringizni shu Telegram/WhatsApp orqali yuboramiz.",
    pleaseEnterTelegram: "Iltimos, Telegram yoki WhatsApp raqamingizni kiriting yoki «bir xil raqam» ni belgilang.",
    
    // Transport methods (for visa change)
    by: "bilan",
    car: "mashina",
    bus: "avtobus",
    airplane: "samolyot",

    // Tourism Software Hub
    tourismSoftware: "Turizm dasturlari",
    tourismSoftwareTitle: "Turizm dasturlari",
    tourismSoftwareSubtitle: "Sayohatchilar, agentliklar va viza arizachilari uchun bepul onlayn vositalar",
    bgRemoverTool: "Fonni olib tashlash",
    bgRemoverDesc: "Sun'iy intellekt yordamida rasmlar fonini bir zumda olib tashlang. PNG yoki JPG formatida yuklab oling.",
    dummyFlightTool: "Namunali aviabilet",
    dummyFlightDesc: "Viza arizalari uchun haqiqiy ko'rinishdagi aviabiletlar yarating. Dunyo bo'ylab istalgan yo'nalish.",
    imageResizerTool: "Rasm o'lchamini o'zgartirish",
    imageResizerDesc: "Rasmlarni o'zgartiring, siqing va konvertatsiya qiling. Fayl hajmini bir zumda kamaytiring.",
    stampMakerTool: "Muhr yaratish vositasi",
    stampMakerDesc: "Biznes hujjatlari va rasmiy qog'ozlar uchun raqamli muhrlar yarating.",
    resumeBuilderTool: "Rezyume yaratish",
    resumeBuilderDesc: "Professional rezyumeni onlayn bepul yarating. Zamonaviy shablonlardan foydalaning va PDF yuklab oling.",
    stampPageH1: "Bepul onlayn muhr yaratish — maxsus raqamli muhrlar yarating",
    stampPageH2: "Hujjatlar, hisob-fakturalar va rasmiy qog'ozlar uchun professional muhrlar yarating",
    stampPageText: "Bepul onlayn vositamiz yordamida sifatli raqamli muhrlarni bir zumda yarating. Kompaniyangiz uchun dumaloq muhr, to'rtburchak tasdiqlash muhri yoki biznes hujjatlari uchun maxsus imzo muhri kerakmi — vositamiz professional muhrlarni bir necha soniyada yaratish va yuklab olish imkonini beradi. BAA va butun dunyo bo'ylab frilanserlar, kichik biznes va korxonalar uchun ideal. Shaklni tanlang, kompaniya nomini, ro'yxatga olish raqamini va logotipni qo'shing — so'ng muhrni shaffof PNG formatida yuklab oling. Ro'yxatdan o'tish shart emas, butunlay bepul.",
    stampToolTitle: "Muhr yaratish vositasi",
    stampComingSoon: "Tez kunda — muhr yaratish uchun kuchli vosita tayyorlanmoqda.",
    resumePageH1: "Professional rezyume yaratish — BAAda va butun dunyoda orzu qilgan ishingizni toping",
    resumePageH2: "Ishga qabul qilinadigan ajoyib CV yarating — bepul, tez va PDF formatida yuklab olishga tayyor",
    resumePageText: "Rezyume — ish beruvchiga qoldiradigan birinchi taassurotingiz, shuning uchun u mukammal bo'lishi kerak. Bizning professional rezyume yaratish vositamiz Dubay, Abu Dabi va butun BAAdagi, shuningdek xalqaro mehnat bozoridagi ish izlovchilar uchun yaratilgan. Tajribali rahbar, soha almashtirayotgan mutaxassis yoki karyerasini boshlayotgan bitiruvchi bo'lsangiz — vositamiz tajribangiz, ko'nikmalaringiz va malakangizni zamonaviy, professional formatda taqdim etishga yordam beradi. Shaxsiy ma'lumotlar, ish tajribasi, ta'lim, tillar va ko'nikmalarni kiriting — tizim bir zumda ATS-mos, sayqallangan rezyumeni PDF formatida yuklab olish uchun yaratadi. Ro'yxatdan o'tish shart emas, suv belgilari yo'q, yashirin to'lovlar yo'q. Yaqin Sharq, Janubiy Osiyo va MDH mamlakatlaridagi minglab mutaxassislar foydalanmoqda.",
    resumeToolTitle: "Rezyume yaratish vositasi",
    resumeComingSoon: "Tez kunda — rezyume yaratish uchun kuchli vosita tayyorlanmoqda.",
    // Freelance Visa Page
    fvPageH1: "Dubay frilanser vizasi 2026 — BAAda mustaqil ishlang, to'liq qonuniy rezidentlik bilan",
    fvPageH2: "BAA frilanser ruxsatnomasi uchun onlayn ariza bering — Tez rasmiylashtirish, Registan Tourism dan to'liq qo'llab-quvvatlash",
    fvPageDesc: "Registan Tourism dan to'liq qonuniy BAA frilanser vizasi bilan Dubayda frilanser karyerangizni boshlang. Bizning to'liq xizmatimiz savdo litsenziyasi berish, viza shtamplash, Emirates ID rasmiylashtirish va tibbiy ko'rikni o'z ichiga oladi — barchasi 5-7 ish kunida. Dizayner, dasturchi, konsultant, kontent yaratuvchi yoki boshqa mustaqil mutaxassis bo'lsangiz — jamoamiz har bir qadamni bajaradi. AED 5,000 dan boshlanadigan shaffof narxlar, yashirin to'lovlarsiz, eshikma-eshik hujjat yetkazib berish va shaxsiy kabinet orqali real vaqtda status kuzatish.",
    fvApplyBtn: "Frilanser vizasi uchun ariza berish",
    fvPrice: "AED 5,000 dan",
    fvDuration: "Rasmiylashtirish: 5-7 kun",
    fvFeaturesTitle: "Nimalar kiritilgan",
    fvFeature1: "Frilanser savdo litsenziyasi",
    fvFeature2: "BAA rezident vizasi shtamplash",
    fvFeature3: "Emirates ID rasmiylashtirish",
    fvFeature4: "Tibbiy ko'rik",
    fvFeature5: "Hujjatlarni olib ketish va yetkazish",
    fvFeature6: "Real vaqtda status kuzatish",
    fvFeature7: "Shaxsiy qo'llab-quvvatlash menejeri",
    fvFeature8: "Yashirin to'lovlar yo'q",
    // Resume Builder
    rbFormTitle: "Rezyume yarating",
    rbPersonal: "Shaxsiy ma'lumotlar",
    rbPhoto: "Rasm",
    rbUploadPhoto: "Rasm yuklash",
    rbFullName: "To'liq ism",
    rbFullNamePh: "Ism Familiya",
    rbJobTitle: "Lavozim",
    rbJobTitlePh: "Dasturchi",
    rbMobile: "Telefon",
    rbEmail: "Elektron pochta",
    rbAddress: "Manzil",
    rbAddressPh: "Dubay, BAA",
    rbAboutMe: "Men haqimda",
    rbAboutMePh: "O'zingiz haqingizda qisqacha yozing...",
    rbWorkExp: "Ish tajribasi",
    rbPosition: "Lavozim",
    rbCompany: "Kompaniya",
    rbCountry: "Mamlakat",
    rbFromYear: "Dan (yil)",
    rbToYear: "Gacha (yil)",
    rbPresent: "Hozirgi kungacha",
    rbAddWork: "Tajriba qo'shish",
    rbEducation: "Ta'lim",
    rbInstitution: "O'quv muassasasi",
    rbCity: "Shahar",
    rbAddEdu: "Ta'lim qo'shish",
    rbSkills: "Ko'nikmalar",
    rbSkillPh: "masalan React, Photoshop",
    rbLanguages: "Tillar",
    rbLangPh: "masalan Ingliz tili",
    rbHobbies: "Sevimli mashg'ulotlar",
    rbHobbyPh: "masalan Fotografiya",
    rbSocialLinks: "Ijtimoiy tarmoqlar",
    rbLinkText: "Havola matni (masalan Mening saytim)",
    rbDownloadPDF: "PDF yuklab olish",
    rbDownloading: "PDF yaratilmoqda...",
    rbDesignStyle: "Dizayn uslubi",
    rbClassic: "Klassik",
    rbModern: "Zamonaviy",
    rbCreative: "Ijodiy",
    rbYourName: "Ismingiz",
    rbCreateResume: "Rezyume yaratish",
    rbFreeForever: "DOIMO BEPUL",
    rbBadge1: "Ro'yxatdan o'tish shart emas",
    rbBadge2: "ATS-mos format",
    rbBadge3: "Butun dunyoda foydalaniladi",

    // Background Remover Page
    bgRemoverTitle: "Fonni olib tashlash",
    bgRemoverSubtitle: "Sun'iy intellekt yordamida rasmlar fonini bir zumda olib tashlang. Istalgan rasmni yuklang va shaffof yoki rangli fon bilan yuklab oling.",
    uploadImage: "Rasmni yuklash",
    dropImageHere: "Rasmni shu yerga tashlang yoki yuklash uchun bosing",
    supportedFormats: "PNG, JPG, WEBP 10MB gacha",
    processing: "Qayta ishlanmoqda...",
    removingBackground: "Fon olib tashlanmoqda...",
    downloadPNG: "PNG yuklab olish",
    downloadJPG: "JPG yuklab olish",
    bgColor: "Fon rangi",
    transparent: "Shaffof",
    removeAnother: "Boshqasini olib tashlash",

    // KeyFlight Page
    flightTicketGenerator: "Aviabilet generatori",
    flightTicketSubtitle: "Viza arizalari uchun professional elektron biletlar yarating. Istalgan yo'nalishni tanlang.",
    passengerName: "Yo'lovchi ismi",
    tripType: "Safar turi",
    oneWay: "Bir tomonga",
    roundTrip: "Borish-qaytish",
    from: "Qayerdan",
    to: "Qayerga",
    departureDate: "Jo'nash sanasi",
    returnDate: "Qaytish sanasi",
    searchFlights: "Reyslarni qidirish",
    selectYourFlight: "Reysni tanlang",
    outboundFlights: "Borish reyslari",
    returnFlights: "Qaytish reyslari",
    generateTicket: "Bilet yaratish",
    back: "Orqaga",
    yourTicketReady: "Elektron biletingiz tayyor!",
    downloadETicket: "Elektron biletni yuklab olish",
    sendToEmail: "Emailga yuborish",
    generateNew: "Yangisini yaratish",
    sendTicketTitle: "Biletni emailga yuborish",
    sendTicketDesc: "Elektron biletni olish uchun email manzilini kiriting.",
    sendETicket: "Biletni yuborish",
    sending: "Yuborilmoqda...",
    ticketSentSuccess: "Elektron bilet muvaffaqiyatli yuborildi!",

    // Image Resizer Page
    imageResizerTitle: "Rasm o'lchamini o'zgartirish",
    imageResizerSubtitle: "Rasmlarni o'zgartiring, kesing, siqing va konvertatsiya qiling. Sifatni yo'qotmasdan fayl hajmini kamaytiring.",
    dropImageUpload: "Rasmni shu yerga tashlang yoki yuklash uchun bosing",
    original: "Asl nusxa",
    fileSize: "Fayl hajmi",
    dimensions: "O'lchamlar",
    cropImage: "Rasmni kesish",
    cancelCrop: "Kesishni bekor qilish",
    aspectRatio: "Tomonlar nisbati",
    free: "Erkin",
    applyCrop: "Kesishni qo'llash",
    widthPx: "Kenglik (piksel)",
    heightPx: "Balandlik (piksel)",
    keepAspectRatio: "Nisbatni saqlash",
    qualityLabel: "Sifat",
    lowQuality: "Past sifat / Kichik hajm",
    highQuality: "Yuqori sifat / Katta hajm",
    outputFormat: "Chiqish formati",
    resizeCompress: "O'zgartirish va siqish",
    newSize: "Yangi hajm",
    reduction: "Kamaytirish",
    download: "Yuklab olish",
    remove: "O'chirish",
    processedPreview: "Qayta ishlangan ko'rinish",
    originalImage: "Asl rasm",
    cropModeDrag: "Kesish rejimi — sozlash uchun suring",
    cropFeatureTitle: "Rasmni kesish",
    cropFeatureDesc: "Rasmni erkin yoki 1:1, 4:3, 16:9 kabi belgilangan nisbatlarda kesing.",
    reduceFileSizeTitle: "Fayl hajmini kamaytirish",
    reduceFileSizeDesc: "Sifatni sozlab rasmlarni siqing. Veb-saytlar, email va ijtimoiy tarmoqlar uchun ideal.",
    customDimensionsTitle: "Maxsus o'lchamlar",
    customDimensionsDesc: "Pikselda aniq kenglik va balandlikni belgilang yoki 50%, 75% kabi tezkor sozlamalardan foydalaning.",
    convertFormatTitle: "Formatni konvertatsiya qilish",
    convertFormatDesc: "JPG, PNG va WebP o'rtasida konvertatsiya qiling. Ehtiyojlaringiz uchun eng yaxshi formatni tanlang.",

    // BgRemover extra keys
    freeTool: "100% bepul",
    freeToolDesc: "Cheklovsiz, suv belgisisiz, ro'yxatdan o'tmasdan.",
    aiPowered: "Sun'iy intellekt",
    aiPoweredDesc: "Odamlar, mahsulotlar va ob'ektlarni aqlli aniqlash.",
    customColors: "Maxsus ranglar",
    customColorsDesc: "Tayyor ranglardan tanlang yoki istalgan fon rangini belgilang.",
    openTool: "Ochish",
    pdfEditorTool: "PDF muharrir",
    pdfEditorDesc: "PDF va rasm hujjatlarni tahrirlang va tozalang. Telefon raqamlarini avtomatik o'chirib tashlang."
  }
};

// Language names and flags
const languageInfo = {
  en: { name: "English", flag: "🇬🇧", short: "EN" },
  ru: { name: "Русский", flag: "🇷🇺", short: "RU" },
  uz: { name: "O'zbek", flag: "🇺🇿", short: "UZ" }
};

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

// Detect user's preferred language
const detectLanguage = () => {
  // Check localStorage first
  const savedLang = localStorage.getItem('preferredLanguage');
  if (savedLang && translations[savedLang]) {
    return savedLang;
  }
  
  // Get browser language
  const browserLang = navigator.language || navigator.userLanguage;
  const langCode = browserLang.split('-')[0].toLowerCase();
  
  // Map languages
  // Russian speakers: ru, uk (Ukraine), be (Belarus), kk (Kazakhstan)
  const russianSpeakers = ['ru', 'uk', 'be', 'kk'];
  // Uzbek speakers
  const uzbekSpeakers = ['uz'];
  
  if (russianSpeakers.includes(langCode)) {
    return 'ru';
  }
  if (uzbekSpeakers.includes(langCode)) {
    return 'uz';
  }
  
  return 'en';
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Check URL path for language prefix first
    const pathLang = window.location.pathname.split('/')[1];
    if (pathLang === 'ru' || pathLang === 'uz') {
      setLanguage(pathLang);
      localStorage.setItem('preferredLanguage', pathLang);
    } else {
      const detectedLang = detectLanguage();
      setLanguage(detectedLang);
    }
    setIsLoaded(true);
  }, []);

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
      localStorage.setItem('preferredLanguage', lang);

      // Update URL to reflect language
      const pathname = window.location.pathname;
      const currentPrefix = pathname.split('/')[1];
      const isLangPrefix = currentPrefix === 'ru' || currentPrefix === 'uz' || currentPrefix === 'en';
      let basePath = isLangPrefix ? '/' + pathname.split('/').slice(2).join('/') : pathname;
      if (!basePath || basePath === '/') basePath = '/';

      let newPath;
      if (lang === 'en') {
        newPath = basePath;
      } else {
        newPath = '/' + lang + (basePath === '/' ? '' : basePath);
      }
      window.history.replaceState(null, '', newPath);
    }
  };

  const t = (key) => {
    return translations[language]?.[key] || translations.en[key] || key;
  };

  const value = {
    language,
    changeLanguage,
    t,
    translations: translations[language],
    languageInfo,
    availableLanguages: Object.keys(translations),
    isLoaded
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
